const data = {
    type: 'Topology',
    arcs: [
        [
            [19197, 10824],
            [81, -45],
            [60, 16],
            [17, 53],
            [63, 18],
            [45, 36],
            [15, 95],
            [67, 23],
            [13, 42],
            [37, -31],
            [24, -4],
        ],
        [
            [19619, 11027],
            [45, -1],
            [60, -25],
        ],
        [
            [19724, 11001],
            [24, -14],
            [58, 38],
            [27, -23],
            [25, 54],
            [48, -2],
            [12, 17],
            [8, 48],
            [35, 41],
            [43, -27],
            [-9, -36],
            [24, -6],
            [-7, -99],
            [31, -39],
            [28, 25],
            [35, 11],
            [50, 54],
            [55, -9],
            [82, 0],
        ],
        [
            [20293, 11034],
            [12, -28],
        ],
        [
            [20305, 11006],
            [-152, -52],
        ],
        [
            [20153, 10954],
            [-24, -3],
            [-86, -25],
            [-46, -52],
            [19, -50],
            [9, -59],
            [-40, -50],
            [4, -46],
            [-22, -42],
            [-76, 3],
            [31, -78],
            [-50, -30],
            [-34, -72],
            [4, -71],
            [-31, -33],
            [-29, 11],
            [-61, -16],
            [-9, -33],
            [-59, 0],
            [-44, -67],
            [-3, -101],
            [-104, -49],
            [-55, 10],
            [-16, -26],
            [-48, 16],
            [-79, -18],
            [-134, 60],
        ],
        [
            [19170, 10133],
            [72, 108],
            [-6, 76],
            [-60, 20],
            [-7, 76],
            [-26, 94],
            [34, 65],
            [-34, 18],
            [22, 86],
            [32, 148],
        ],
        [
            [16229, 5300],
            [8, -37],
            [-9, -58],
            [14, -55],
            [-12, -45],
            [7, -41],
            [-166, 2],
            [-4, -378],
            [54, -97],
            [52, -74],
        ],
        [
            [16173, 4517],
            [-146, -48],
            [-193, 17],
            [-55, 57],
            [-323, -5],
            [-12, -9],
            [-47, 54],
            [-52, 3],
            [-47, -20],
            [-39, -22],
        ],
        [
            [15259, 4544],
            [-7, 74],
            [11, 104],
            [27, 109],
            [5, 51],
            [25, 107],
            [19, 48],
            [46, 78],
            [26, 53],
            [8, 88],
            [-4, 67],
            [-24, 42],
            [-21, 72],
            [-20, 71],
            [4, 25],
            [25, 47],
            [-24, 115],
            [-17, 79],
            [-39, 75],
            [7, 23],
        ],
        [
            [15306, 5872],
            [33, 16],
            [23, -2],
            [28, 14],
            [235, -1],
            [19, -89],
            [23, -71],
            [19, -38],
            [30, -62],
            [53, 9],
            [26, 17],
            [44, -17],
            [12, 30],
            [20, 69],
            [49, 5],
            [5, 20],
            [40, 1],
            [-7, -43],
            [97, 1],
            [1, -75],
            [16, -45],
            [-11, -72],
            [5, -73],
            [27, -44],
            [-4, -141],
            [19, 11],
            [35, -3],
            [49, 18],
            [37, -7],
        ],
        [
            [15295, 5909],
            [-21, 89],
        ],
        [
            [15274, 5998],
            [32, 51],
            [24, 20],
            [30, -40],
        ],
        [
            [15360, 6029],
            [-29, -25],
            [-13, -31],
            [-3, -52],
            [-20, -12],
        ],
        [
            [15998, 11440],
            [-1, -32],
            [-26, -17],
            [-5, -38],
            [-37, -58],
        ],
        [
            [15929, 11295],
            [-13, 8],
            [-2, 27],
            [-44, 39],
            [-7, 57],
            [7, 81],
            [11, 37],
            [-14, 18],
            [0, 0],
        ],
        [
            [15867, 11562],
            [-5, 38],
            [34, 58],
            [5, -22],
            [22, 11],
        ],
        [
            [15923, 11647],
            [17, -32],
            [19, -12],
            [5, -43],
        ],
        [
            [15964, 11560],
            [0, 0],
            [-10, -41],
            [11, -51],
            [33, -28],
        ],
        [
            [18431, 9471],
            [14, 6],
            [3, -33],
            [62, 19],
            [66, -3],
            [48, -4],
            [54, 81],
            [60, 76],
            [50, 73],
        ],
        [
            [18788, 9686],
            [15, -41],
        ],
        [
            [18803, 9645],
            [11, -93],
        ],
        [
            [18814, 9552],
            [-41, -1],
            [-6, -77],
            [14, -16],
            [-36, -24],
            [0, -48],
            [-24, -49],
            [-2, -48],
        ],
        [
            [18719, 9289],
            [-16, -25],
            [-239, 60],
            [-30, 120],
            [-3, 27],
        ],
        [
            [8996, 85],
            [-48, 3],
            [-85, 0],
            [0, 265],
        ],
        [
            [8863, 353],
            [31, -55],
            [40, -89],
            [103, -71],
            [111, -30],
            [-35, -59],
            [-76, -6],
            [-41, 42],
        ],
        [
            [9337, 3957],
            [146, -194],
            [65, -18],
            [97, -87],
            [82, -47],
            [12, -52],
            [-79, -180],
            [81, -33],
            [89, -18],
            [63, 19],
            [72, 91],
            [13, 105],
        ],
        [
            [9978, 3543],
            [39, 23],
            [40, -69],
            [-1, -95],
            [-67, -65],
            [-54, -48],
            [-89, -115],
            [-107, -162],
        ],
        [
            [9739, 3012],
            [-20, -95],
            [-21, -122],
            [1, -118],
            [-17, -26],
            [-6, -77],
        ],
        [
            [9676, 2574],
            [-6, -62],
            [101, -102],
            [-11, -81],
            [50, -52],
            [-4, -58],
            [-77, -152],
            [-118, -64],
            [-159, -24],
            [-88, 12],
            [17, -71],
            [-16, -89],
            [15, -60],
            [-48, -41],
            [-82, -17],
            [-76, 43],
            [-31, -31],
            [11, -118],
            [54, -35],
            [43, 37],
            [24, -61],
            [-73, -37],
            [-64, -74],
            [-12, -119],
            [-19, -64],
            [-75, 0],
            [-62, -61],
            [-23, -89],
            [78, -87],
            [76, -24],
            [-27, -106],
            [-94, -67],
            [-52, -139],
            [-72, -47],
            [-33, -55],
            [26, -123],
            [53, -69],
            [-34, 6],
        ],
        [
            [8868, 393],
            [-74, 18],
            [-192, 16],
            [-33, 69],
            [2, 89],
            [-53, -7],
            [-28, 43],
            [-7, 125],
            [61, 53],
            [25, 75],
            [-9, 60],
            [42, 101],
            [29, 157],
            [-9, 70],
            [35, 22],
            [-8, 45],
            [-37, 24],
            [26, 49],
            [-36, 45],
            [-19, 137],
            [32, 24],
            [-13, 145],
            [19, 121],
            [21, 106],
            [48, 43],
            [-25, 116],
            [0, 109],
            [60, 77],
            [-1, 99],
            [45, 116],
            [0, 109],
            [-20, 22],
            [-37, 205],
            [49, 122],
            [-8, 115],
            [29, 107],
            [52, 112],
            [56, 73],
            [-24, 47],
            [17, 38],
            [-3, 198],
            [87, 58],
            [27, 123],
            [-9, 30],
        ],
        [
            [8985, 3899],
            [66, 107],
            [104, -29],
            [47, -85],
            [31, 95],
            [91, -5],
            [13, -25],
        ],
        [
            [17794, 11469],
            [111, 19],
        ],
        [
            [17905, 11488],
            [16, -31],
            [30, -21],
            [-16, -30],
            [43, -40],
            [-23, -38],
            [34, -32],
            [36, -20],
            [2, -82],
        ],
        [
            [18027, 11194],
            [-29, -4],
        ],
        [
            [17998, 11190],
            [-33, 69],
            [1, 18],
            [-35, 0],
            [-24, 32],
            [-17, -3],
        ],
        [
            [17890, 11306],
            [-31, 34],
            [-59, 30],
            [8, 57],
            [-14, 42],
        ],
        [
            [19812, 829],
            [51, -38],
            [75, -15],
            [3, -22],
            [-22, -54],
            [-122, -8],
            [-2, 63],
            [11, 49],
            [6, 25],
        ],
        [
            [25897, 1758],
            [77, -41],
            [43, 16],
            [63, 23],
            [47, -8],
            [6, -141],
            [-27, -41],
            [-9, -95],
            [-27, 32],
            [-56, -82],
            [-16, 6],
            [-49, 4],
            [-49, 101],
            [-11, 78],
            [-46, 104],
            [2, 54],
            [52, -10],
        ],
        [
            [25751, 4963],
            [29, -93],
            [51, 45],
            [26, -50],
            [38, -47],
            [-8, -52],
            [17, -102],
            [12, -59],
            [20, -15],
            [22, -101],
            [-8, -61],
            [26, -81],
            [86, -62],
            [56, -56],
            [54, -52],
            [-11, -29],
            [46, -74],
            [31, -128],
            [32, 26],
            [32, -52],
            [19, 19],
            [14, -126],
            [56, -73],
            [37, -45],
            [63, -96],
            [22, -95],
            [2, -68],
            [-5, -73],
            [37, -101],
            [-4, -105],
            [-14, -55],
            [-21, -106],
            [1, -68],
            [-15, -85],
            [-36, -108],
            [-59, -58],
            [-29, -92],
            [-26, -59],
            [-24, -102],
            [-30, -59],
            [-21, -89],
            [-10, -82],
            [4, -37],
            [-45, -41],
            [-90, -5],
            [-73, -48],
            [-37, -46],
            [-48, -51],
            [-66, 52],
            [-48, 21],
            [12, 62],
            [-43, -22],
            [-70, -86],
            [-69, 32],
            [-45, 19],
            [-46, 8],
            [-77, 34],
            [-51, 74],
            [-15, 90],
            [-18, 60],
            [-39, 48],
            [-77, 14],
            [26, 57],
            [-19, 89],
            [-39, -83],
            [-71, -21],
            [42, 65],
            [12, 69],
            [31, 58],
            [-7, 88],
            [-64, -101],
            [-50, -41],
            [-31, -94],
            [-62, 48],
            [3, 63],
            [-50, 86],
            [-42, 45],
            [15, 27],
            [-102, 72],
            [-56, 3],
            [-77, 58],
            [-142, -11],
            [-103, -43],
            [-91, -39],
            [-76, 8],
            [-84, -61],
            [-69, -27],
            [-16, -63],
            [-29, -48],
            [-67, -3],
            [-50, -10],
            [-71, 21],
            [-57, -13],
            [-55, -5],
            [-47, -63],
            [-23, 5],
            [-40, -33],
            [-38, -38],
            [-58, 5],
            [-54, 0],
            [-84, 75],
            [-43, 23],
            [2, 68],
            [39, 16],
            [14, 27],
            [-3, 43],
            [10, 82],
            [-9, 70],
            [-42, 120],
            [-13, 68],
            [3, 68],
            [-32, 77],
            [-2, 35],
            [-35, 47],
            [-10, 93],
            [-45, 94],
            [-11, 50],
            [35, -51],
            [-27, 110],
            [39, -34],
            [24, -46],
            [-1, 60],
            [-40, 94],
            [-8, 37],
            [-18, 36],
            [9, 68],
            [16, 29],
            [11, 60],
            [-9, 69],
            [33, 85],
            [6, -90],
            [34, 82],
            [65, 39],
            [38, 51],
            [61, 43],
            [36, 10],
            [22, -15],
            [63, 44],
            [48, 13],
            [12, 26],
            [21, 11],
            [44, -3],
            [84, 35],
            [43, 53],
            [21, 63],
            [46, 60],
            [4, 48],
            [2, 64],
            [56, 101],
            [33, -102],
            [34, 23],
            [-28, 56],
            [25, 58],
            [35, -26],
            [9, 90],
            [44, 59],
            [19, 47],
            [40, 20],
            [1, 33],
            [35, -14],
            [2, 30],
            [35, 17],
            [38, 16],
            [59, -55],
            [44, -70],
            [50, -1],
            [51, -11],
            [-17, 65],
            [38, 95],
            [36, 31],
            [-13, 30],
            [35, 68],
            [48, 42],
            [41, -14],
            [67, 22],
            [-2, 60],
            [-58, 40],
            [42, 17],
            [53, -30],
            [42, -48],
            [67, -31],
            [23, 12],
            [49, -36],
            [47, 34],
            [30, -10],
            [18, 22],
            [37, -58],
            [-21, -64],
            [-30, -48],
            [-28, -4],
            [9, -47],
            [-23, -59],
            [-28, -59],
            [5, -33],
            [64, -66],
            [61, -38],
            [41, -41],
            [58, -70],
            [22, 0],
            [42, -30],
            [12, -37],
            [76, -40],
            [52, 41],
            [16, 63],
            [16, 53],
            [10, 65],
            [24, 94],
            [-11, 58],
            [6, 34],
            [-9, 68],
            [10, 89],
            [15, 24],
            [-12, 40],
            [19, 63],
            [15, 65],
            [2, 34],
            [30, 44],
            [22, -58],
            [6, -74],
            [20, -14],
            [3, -50],
            [29, -61],
            [6, -67],
            [-3, -43],
        ],
        [
            [15677, 12303],
            [-6, -48],
            [-45, -1],
            [15, -25],
            [-26, -77],
        ],
        [
            [15615, 12152],
            [-15, -20],
            [-70, -3],
            [-40, -27],
            [-66, 10],
        ],
        [
            [15424, 12112],
            [-114, 30],
            [-17, 42],
            [-79, -21],
            [-9, -23],
            [-48, 17],
        ],
        [
            [15157, 12157],
            [-41, 3],
            [-36, 22],
            [12, 29],
            [-3, 21],
        ],
        [
            [15089, 12232],
            [24, 7],
            [40, -33],
            [12, 31],
            [70, -5],
            [57, 21],
            [38, -3],
            [25, -25],
            [7, 20],
            [-11, 78],
            [28, 15],
            [29, 54],
        ],
        [
            [15408, 12392],
            [59, -38],
            [44, 49],
            [28, 9],
            [62, -37],
            [38, 7],
            [36, -23],
        ],
        [
            [15675, 12359],
            [-6, -15],
            [8, -41],
        ],
        [
            [17998, 11190],
            [-55, 16],
            [-40, 55],
            [-13, 45],
        ],
        [
            [17905, 11488],
            [19, 19],
            [59, -34],
            [43, -7],
            [11, 14],
            [-39, 64],
            [21, 16],
        ],
        [
            [18019, 11560],
            [22, -4],
            [55, -72],
            [35, -8],
            [14, 30],
            [47, 48],
        ],
        [
            [18192, 11554],
            [42, -62],
            [40, -84],
            [38, -6],
            [24, -32],
            [-65, -9],
            [-14, -93],
            [-14, -41],
            [-29, -28],
            [2, -59],
        ],
        [
            [18216, 11140],
            [-20, -5],
            [-50, 62],
            [28, 58],
            [-24, 35],
            [-29, -9],
            [-94, -87],
        ],
        [
            [16661, 6062],
            [-6, 143],
            [-20, 54],
        ],
        [
            [16635, 6259],
            [49, -9],
            [24, 67],
            [42, -8],
        ],
        [
            [16750, 6309],
            [5, -46],
            [17, -27],
            [1, -39],
            [-20, -25],
            [-31, -61],
            [-29, -43],
            [-32, -6],
        ],
        [
            [14648, 12676],
            [73, 25],
            [51, -52],
            [43, -28],
        ],
        [
            [14815, 12621],
            [-9, -80],
        ],
        [
            [14806, 12541],
            [-20, -5],
            [-9, -66],
        ],
        [
            [14777, 12470],
            [-70, 54],
            [-40, -9],
            [-56, 56],
            [-37, 47],
            [-37, 2],
            [-11, 42],
        ],
        [
            [14526, 12662],
            [63, 23],
            [0, 0],
        ],
        [
            [14589, 12685],
            [0, 0],
            [59, -9],
        ],
        [
            [14540, 7338],
            [-66, -14],
        ],
        [
            [14474, 7324],
            [-20, 82],
            [4, 272],
            [-16, 25],
            [-3, 58],
            [-28, 41],
            [-24, 35],
            [10, 63],
        ],
        [
            [14397, 7900],
            [27, 13],
            [17, 52],
            [39, 11],
            [17, 36],
        ],
        [
            [14497, 8012],
            [27, 34],
            [28, 1],
            [61, -68],
        ],
        [
            [14613, 7979],
            [-3, -40],
            [18, -70],
            [-16, -48],
            [8, -32],
            [-38, -73],
            [-25, -37],
            [-15, -74],
            [2, -76],
            [-4, -191],
        ],
        [
            [14397, 7900],
            [-70, 2],
        ],
        [
            [14327, 7902],
            [-36, 10],
            [-26, -19],
            [-35, 8],
            [-139, -5],
            [-1, -67],
            [10, -90],
        ],
        [
            [14100, 7739],
            [-54, 31],
            [-37, -5],
            [-28, -30],
            [-36, 26],
            [-14, 39],
            [-36, 26],
        ],
        [
            [13895, 7826],
            [-5, 68],
            [22, 51],
            [-2, 40],
            [63, 98],
            [12, 82],
            [22, 28],
            [38, -16],
            [33, 25],
            [11, 30],
            [62, 53],
            [15, 37],
            [75, 50],
            [43, 16],
            [20, -22],
            [51, 0],
        ],
        [
            [14355, 8366],
            [-6, -57],
            [11, -54],
            [45, -78],
            [2, -57],
            [92, -27],
            [-2, -81],
        ],
        [
            [21701, 9210],
            [-2, -85],
            [-27, 18],
            [5, -96],
        ],
        [
            [21677, 9047],
            [-23, 62],
            [-5, 60],
            [-15, 58],
            [-33, 69],
            [-73, 4],
            [7, -49],
            [-25, -66],
            [-34, 24],
            [-11, -21],
            [-23, 13],
            [-31, 10],
            [-12, 98],
            [-28, 89],
        ],
        [
            [21371, 9398],
            [14, 72],
            [-49, 32],
            [17, 43],
            [19, 16],
            [31, 28],
            [-31, 34],
            [-26, 29],
            [22, 64],
            [6, 16],
            [34, -28],
            [29, -23],
            [38, -6],
            [7, -82],
            [76, -17],
            [73, 2],
            [42, -18],
            [4, -2],
            [-21, -59],
            [-15, -41],
            [-14, -3],
            [-22, -4],
            [-4, -11],
            [-21, -57],
            [33, -46],
            [11, -15],
            [0, 0],
            [4, 25],
            [9, 50],
            [15, 1],
            [7, 0],
            [42, -188],
            [0, 0],
        ],
        [
            [16129, 11842],
            [23, -49],
            [30, 9],
            [62, -19],
            [116, -6],
            [40, 30],
            [94, 28],
            [58, -43],
            [46, -13],
        ],
        [
            [16598, 11779],
            [-41, -49],
            [-29, -85],
            [26, -67],
        ],
        [
            [16554, 11578],
            [-69, 16],
            [-81, -38],
        ],
        [
            [16404, 11556],
            [-1, -59],
            [-72, -11],
            [-56, 42],
            [-64, -33],
            [-59, 3],
        ],
        [
            [16152, 11498],
            [-5, 79],
            [-40, 38],
        ],
        [
            [16107, 11615],
            [13, 17],
            [-9, 14],
            [14, 37],
            [30, 37],
            [-39, 52],
            [-7, 43],
            [20, 27],
        ],
        [
            [8155, 9414],
            [-20, -6],
            [-20, 68],
            [-30, 34],
            [18, 76],
            [24, -5],
            [27, -99],
            [1, -68],
        ],
        [
            [8132, 9748],
            [-87, -19],
            [-5, 44],
            [37, 9],
            [53, -3],
            [2, -31],
        ],
        [
            [8197, 9749],
            [-13, -84],
            [-15, 15],
            [1, 62],
            [-35, 47],
            [-1, 14],
            [63, -54],
        ],
        [
            [15867, 11916],
            [-20, -52],
            [38, -45],
            [-11, -56],
            [-19, -5],
        ],
        [
            [15855, 11758],
            [-15, -11],
            [-26, -28],
            [-11, -65],
        ],
        [
            [15803, 11654],
            [-71, 45],
            [-30, 49],
            [-30, 27],
            [-37, 44],
            [-17, 37],
            [-39, 55],
            [17, 49],
            [28, -27],
            [17, 25],
            [38, 2],
            [68, -19],
            [55, 1],
            [36, -26],
        ],
        [
            [15838, 11916],
            [0, 0],
            [29, 0],
        ],
        [
            [16195, 12990],
            [76, -1],
            [87, 45],
            [18, 67],
            [66, 37],
            [-8, 54],
        ],
        [
            [16434, 13192],
            [48, 20],
            [86, 45],
        ],
        [
            [16568, 13257],
            [84, -29],
            [11, -30],
            [42, 14],
            [78, -28],
            [7, -56],
            [-17, -32],
            [50, -77],
            [33, -22],
            [-5, -21],
            [54, -21],
            [22, -32],
            [-31, -26],
            [-64, 4],
            [-15, -11],
            [19, -39],
            [19, -76],
            [0, 0],
        ],
        [
            [16855, 12775],
            [-68, -7],
            [-25, -26],
            [-5, -60],
            [-31, 12],
            [-72, -6],
            [-21, 28],
            [-30, -21],
            [-30, 17],
            [-63, 3],
            [-88, 28],
            [-81, 9],
            [-61, -2],
            [-44, -33],
            [-38, -4],
        ],
        [
            [16198, 12713],
            [-2, 53],
            [-24, 55],
            [48, 24],
            [0, 47],
            [-22, 45],
            [-3, 53],
        ],
        [
            [7231, 8708],
            [-1, 17],
            [10, 6],
            [14, -14],
            [29, 71],
            [15, 2],
        ],
        [
            [7298, 8790],
            [0, -18],
            [15, 0],
            [-1, -32],
            [-13, -52],
            [7, -18],
            [-8, -43],
            [5, -11],
            [-9, -60],
            [-16, -31],
            [-14, -4],
            [-16, -41],
        ],
        [
            [7248, 8480],
            [-24, 0],
            [6, 134],
            [1, 94],
        ],
        [
            [8985, 3899],
            [-58, -16],
            [-31, 163],
            [-43, 133],
            [25, 115],
            [-41, 50],
            [-11, 86],
            [-39, 81],
        ],
        [
            [8787, 4511],
            [50, 128],
            [-34, 99],
            [18, 40],
            [-14, 44],
            [31, 59],
            [2, 101],
            [4, 84],
            [17, 40],
            [-69, 191],
        ],
        [
            [8792, 5297],
            [59, -10],
            [41, 2],
            [18, 36],
            [69, 48],
            [42, 45],
            [104, 20],
            [-8, -89],
            [10, -46],
            [-7, -79],
            [87, -106],
            [89, -20],
            [31, -44],
            [54, -24],
            [33, -34],
            [50, 1],
            [46, -35],
            [4, -69],
            [15, -34],
            [1, -52],
            [-23, -2],
            [31, -138],
            [152, -5],
            [-11, -68],
            [8, -47],
            [44, -33],
            [18, -74],
            [-14, -93],
            [-22, -52],
            [8, -68],
            [-25, -24],
        ],
        [
            [9696, 4203],
            [-1, 36],
            [-74, 61],
            [-74, 2],
            [-139, -35],
            [-38, -104],
            [-2, -64],
            [-31, -142],
        ],
        [
            [9978, 3543],
            [16, 68],
            [10, 70],
            [1, 66],
            [-29, 21],
            [-30, -19],
            [-30, 5],
            [-9, 46],
            [-7, 109],
            [-15, 35],
            [-54, 32],
            [-32, -23],
            [-84, 23],
            [5, 161],
            [-24, 66],
        ],
        [
            [8792, 5297],
            [-45, -21],
            [-36, 14],
            [5, 180],
            [-65, -70],
            [-70, 3],
            [-31, 64],
            [-52, 6],
            [16, 51],
            [-44, 72],
            [-33, 107],
            [21, 22],
            [0, 50],
            [48, 34],
            [-8, 64],
            [21, 42],
            [5, 55],
            [91, 81],
            [66, 23],
            [10, 17],
            [72, -5],
        ],
        [
            [8763, 6086],
            [36, 325],
            [2, 51],
            [-13, 68],
            [-35, 44],
            [0, 86],
            [45, 19],
            [16, -12],
            [3, 46],
            [-47, 12],
            [-1, 74],
            [155, -3],
            [26, 41],
            [23, -37],
            [15, -70],
            [15, 14],
        ],
        [
            [9003, 6744],
            [44, -62],
            [62, 7],
            [15, 37],
            [59, 27],
            [33, 20],
            [9, 50],
            [57, 34],
            [-4, 25],
            [-67, 10],
            [-12, 74],
            [4, 80],
            [-36, 31],
            [15, 11],
            [59, -16],
            [63, -29],
            [23, 28],
            [57, 18],
            [89, 45],
            [29, 45],
            [-10, 33],
        ],
        [
            [9492, 7212],
            [41, 6],
            [19, -28],
            [-11, -52],
            [28, -18],
            [18, -55],
            [-22, -42],
            [-13, -101],
            [21, -60],
            [6, -54],
            [48, -56],
            [40, -6],
            [8, 23],
            [25, 5],
            [36, 21],
            [26, 32],
            [44, -10],
            [20, 4],
        ],
        [
            [9826, 6821],
            [43, -10],
            [7, 24],
            [-13, 24],
            [8, 34],
            [32, -10],
            [37, 12],
            [46, -25],
        ],
        [
            [9986, 6870],
            [35, -25],
            [24, 32],
            [18, -4],
            [11, -34],
            [38, 9],
            [31, 45],
            [24, 87],
            [47, 109],
        ],
        [
            [10214, 7089],
            [27, 5],
            [20, -65],
            [45, -208],
            [42, -19],
            [2, -82],
            [-59, -98],
            [24, -36],
            [141, -18],
            [3, -119],
            [60, 78],
            [100, -43],
            [133, -72],
            [38, -70],
            [-13, -66],
            [93, 37],
            [155, -63],
            [119, 5],
            [117, -98],
            [102, -133],
            [61, -34],
            [68, -5],
            [29, -38],
            [27, -151],
            [13, -71],
            [-31, -196],
            [-41, -78],
            [-112, -165],
            [-51, -134],
            [-59, -103],
            [-19, -2],
            [-23, -87],
            [6, -223],
            [-22, -182],
            [-9, -79],
            [-25, -46],
            [-14, -159],
            [-81, -155],
            [-13, -122],
            [-65, -52],
            [-18, -71],
            [-87, 1],
            [-125, -46],
            [-56, -53],
            [-89, -34],
            [-94, -95],
            [-67, -117],
            [-12, -89],
            [14, -65],
            [-15, -120],
            [-18, -58],
            [-56, -65],
            [-88, -209],
            [-70, -94],
            [-54, -56],
            [-37, -113],
            [-52, -67],
        ],
        [
            [10078, 2591],
            [-22, 67],
            [35, 56],
            [-46, 81],
            [-63, 65],
            [-82, 76],
            [-29, -3],
            [-80, 92],
            [-52, -13],
        ],
        [
            [23415, 7132],
            [31, 45],
            [68, 65],
        ],
        [
            [23514, 7242],
            [-4, -59],
            [-4, -75],
            [-38, 3],
            [-17, -40],
            [-36, 61],
        ],
        [
            [21639, 9870],
            [17, -18],
            [-6, -73],
            [-65, -4],
            [-31, 4],
            [-36, 4],
            [-17, -6],
            [-33, -12],
            [-72, 45],
            [-1, 14],
            [-1, 9],
            [0, 0],
        ],
        [
            [21394, 9833],
            [53, 89],
            [43, 30],
            [56, -28],
            [42, -3],
            [35, -32],
        ],
        [
            [21623, 9889],
            [0, 0],
            [16, -19],
        ],
        [
            [16668, 3976],
            [-113, -88],
            [-71, -88],
            [-27, -79],
            [-24, -45],
            [-43, -9],
            [-14, -57],
            [-8, -37],
            [-51, -28],
            [-65, 6],
            [-38, 33],
            [-33, 15],
            [-39, -28],
            [-19, -57],
            [-38, -35],
            [-40, -53],
            [-57, -12],
            [-18, 41],
            [8, 73],
            [-48, 112],
            [-21, 18],
        ],
        [
            [15909, 3658],
            [0, 346],
            [78, 4],
            [3, 423],
            [59, 4],
            [123, 41],
            [30, -49],
            [51, 47],
            [24, 0],
            [45, 27],
        ],
        [
            [16322, 4501],
            [14, -9],
        ],
        [
            [16336, 4492],
            [31, -95],
            [16, -21],
            [25, -69],
            [90, -130],
            [34, -13],
            [0, -41],
            [24, -76],
            [61, -18],
            [51, -53],
        ],
        [
            [15542, 7476],
            [65, 9],
            [15, 30],
            [13, -2],
            [20, -27],
            [100, 45],
            [34, 47],
            [42, 41],
            [-8, 42],
            [22, 11],
            [77, -7],
            [75, 54],
            [57, 130],
            [41, 48],
            [50, 20],
        ],
        [
            [16145, 7917],
            [9, -51],
            [46, -74],
            [0, -48],
            [-13, -50],
            [6, -36],
            [27, -35],
            [7, -5],
        ],
        [
            [16227, 7618],
            [54, -46],
            [43, -48],
            [1, -39],
            [54, -62],
            [33, -51],
            [20, -71],
            [59, -47],
            [13, -38],
        ],
        [
            [16504, 7216],
            [-26, -12],
            [-51, 3],
            [-60, 12],
            [-30, -10],
            [-12, -29],
            [-25, -4],
            [-32, 26],
            [-88, -60],
            [-37, 12],
            [-11, -9],
            [-23, -72],
            [-60, 24],
            [-58, 11],
            [-51, 44],
            [-65, 40],
            [-43, -38],
            [-31, -60],
            [-7, -83],
        ],
        [
            [15794, 7011],
            [-51, 7],
            [-54, 20],
            [-47, -63],
            [-42, -110],
        ],
        [
            [15600, 6865],
            [-8, 34],
            [-4, 54],
            [-36, 38],
            [-30, 61],
            [-7, 43],
            [-37, 62],
            [6, 35],
            [-8, 50],
            [6, 92],
            [20, 22],
            [40, 120],
        ],
        [
            [9259, 12116],
            [57, -15],
            [74, 3],
            [-39, -49],
            [-29, -8],
            [-101, 51],
            [-20, 40],
            [30, 36],
            [28, -58],
        ],
        [
            [9407, 12420],
            [-39, -3],
            [-103, 38],
            [-74, 56],
            [27, 10],
            [105, -30],
            [81, -50],
            [3, -21],
        ],
        [
            [4496, 12349],
            [-40, -17],
            [-131, 54],
            [-24, 42],
            [-71, 42],
            [-14, 34],
            [-82, 21],
            [-31, 65],
            [7, 27],
            [84, -26],
            [48, -18],
            [75, -12],
            [27, -41],
            [40, -57],
            [79, -49],
            [33, -65],
        ],
        [
            [9858, 12607],
            [-53, -104],
            [52, 40],
            [54, -25],
            [-28, -41],
            [70, -33],
            [37, 29],
            [80, -36],
            [-25, -87],
            [56, 20],
            [10, -63],
            [24, -74],
            [-33, -104],
            [-36, -4],
            [-52, 22],
            [17, 97],
            [-22, 15],
            [-93, -103],
            [-47, 4],
            [56, 56],
            [-76, 29],
            [-86, -7],
            [-154, 3],
            [-12, 36],
            [49, 41],
            [-35, 33],
            [67, 71],
            [83, 189],
            [49, 67],
            [69, 41],
            [37, -5],
            [-16, -32],
            [-42, -75],
        ],
        [
            [3764, 13005],
            [76, 9],
            [-24, -134],
            [69, -96],
            [-31, 0],
            [-48, 55],
            [-30, 54],
            [-40, 37],
            [-15, 52],
            [5, 38],
            [38, -15],
        ],
        [
            [8017, 13968],
            [-31, -63],
            [-35, 10],
            [-21, 36],
            [4, 8],
            [30, 36],
            [33, -3],
            [20, -24],
        ],
        [
            [7808, 14033],
            [-94, -65],
            [-56, 2],
            [-17, 33],
            [59, 54],
            [109, -1],
            [-1, -23],
        ],
        [
            [7548, 14383],
            [15, -53],
            [40, 19],
            [47, -31],
            [87, -41],
            [91, -37],
            [7, -56],
            [59, 9],
            [56, -39],
            [-70, -38],
            [-124, 29],
            [-45, 53],
            [-79, -63],
            [-113, -61],
            [-27, 69],
            [-108, -11],
            [69, 58],
            [10, 94],
            [27, 108],
            [58, -9],
        ],
        [
            [8288, 14560],
            [-90, -6],
            [-19, 58],
            [33, 66],
            [73, 17],
            [62, -33],
            [1, -51],
            [-9, -16],
            [-51, -35],
        ],
        [
            [6713, 14792],
            [-49, -42],
            [-107, 36],
            [-65, -13],
            [-109, 54],
            [70, 36],
            [56, 52],
            [84, -34],
            [48, -21],
            [24, -23],
            [48, -45],
        ],
        [
            [8982, 11949],
            [-52, 67],
            [0, 162],
            [-35, 34],
            [-53, -20],
            [-27, 31],
            [-61, -90],
            [-24, -92],
            [-28, -54],
            [-34, -18],
            [-25, -6],
            [-8, -29],
            [-147, 0],
            [-121, -1],
            [-36, -22],
            [-84, -86],
            [-10, -9],
            [-25, -46],
            [-73, 0],
            [-79, 0],
            [-35, -19],
            [12, -24],
            [8, -36],
            [-2, -12],
            [-104, -59],
            [-82, -18],
            [-93, -64],
            [-19, 0],
            [-28, 19],
            [-8, 17],
            [1, 12],
            [18, 42],
            [37, 65],
            [23, 70],
            [-15, 103],
            [-17, 108],
            [-83, 56],
            [9, 21],
            [-11, 14],
            [-22, 0],
            [-16, 19],
            [-4, 28],
            [-16, -12],
            [-21, 3],
            [5, 12],
            [-19, 12],
            [-7, 31],
            [-62, 38],
            [-65, 39],
            [-77, 46],
            [-75, 43],
            [-71, -33],
            [-26, -1],
            [-98, 30],
            [-65, -15],
            [-77, 37],
            [-81, 19],
            [-56, 7],
            [-25, 20],
            [-14, 65],
            [-27, 0],
            [0, -46],
            [-165, 0],
            [-272, 0],
            [-270, 0],
            [-239, 0],
            [-239, 0],
            [-235, 0],
            [-242, 0],
            [-79, 0],
            [-236, 0],
            [-226, 0],
        ],
        [
            [4549, 12407],
            [-11, 0],
            [-154, 117],
            [-56, 51],
            [-145, 49],
            [-44, 105],
            [11, 73],
            [-101, 50],
            [-14, 96],
            [-97, 86],
            [-1, 61],
        ],
        [
            [3937, 13095],
            [0, 0],
            [44, 57],
            [-2, 75],
            [-136, 76],
            [-81, 135],
            [-50, 85],
            [-73, 54],
            [-53, 48],
            [-42, 61],
            [-80, -38],
            [-78, -66],
            [-71, 78],
            [-55, 52],
            [-78, 32],
            [-78, 4],
            [0, 675],
            [1, 441],
        ],
        [
            [3105, 14864],
            [0, 0],
            [148, -29],
            [126, -57],
            [83, -11],
            [70, 49],
            [96, 37],
            [118, -14],
            [119, 52],
            [131, 30],
            [54, -50],
            [60, 28],
            [17, 56],
            [55, -13],
            [135, -106],
            [106, 80],
            [11, -90],
            [98, 20],
            [30, 35],
            [96, -7],
            [122, -50],
            [186, -44],
            [109, -20],
            [78, 8],
            [108, -60],
            [-112, -59],
            [144, -26],
            [215, 14],
            [67, 21],
            [85, -71],
            [87, 60],
            [-82, 50],
            [52, 41],
            [97, 5],
            [63, 12],
            [65, -28],
            [80, -64],
            [89, 9],
            [140, -53],
            [124, 18],
            [116, -2],
            [-9, 73],
            [70, 21],
            [124, -40],
            [-1, -112],
            [51, 94],
            [64, -3],
            [36, 119],
            [-85, 73],
            [-93, 48],
            [6, 131],
            [94, 86],
            [105, -19],
            [81, -52],
            [108, -134],
            [-71, -58],
            [148, -24],
            [0, -121],
            [106, 93],
            [95, -77],
            [-23, -88],
            [77, -80],
            [83, 86],
            [58, 103],
            [4, 130],
            [113, -9],
            [118, -18],
            [107, -59],
            [5, -59],
            [-60, -63],
            [56, -63],
            [-10, -58],
            [-156, -83],
            [-110, -18],
            [-83, 35],
            [-23, -59],
            [-77, -100],
            [-23, -52],
            [-93, -80],
            [-113, -8],
            [-63, -50],
            [-6, -77],
            [-92, -15],
            [-98, -96],
            [-86, -134],
            [-31, -93],
            [-4, -138],
            [117, -20],
            [36, -111],
            [37, -90],
            [111, 24],
            [148, -52],
            [80, -45],
            [57, -56],
            [99, -32],
            [85, -50],
            [131, -7],
            [87, -12],
            [-13, -102],
            [24, -120],
            [58, -132],
            [119, -113],
            [61, 39],
            [43, 122],
            [-42, 187],
            [-56, 62],
            [128, 56],
            [90, 83],
            [44, 83],
            [-7, 79],
            [-54, 101],
            [-96, 89],
            [94, 124],
            [-35, 108],
            [-27, 185],
            [56, 27],
            [136, -32],
            [82, -12],
            [66, 32],
            [74, -41],
            [98, -68],
            [24, -46],
            [142, -9],
            [-2, -100],
            [26, -150],
            [73, -19],
            [58, -69],
            [115, 65],
            [76, 131],
            [53, 55],
            [62, -105],
            [103, -152],
            [88, -142],
            [-32, -74],
            [106, -67],
            [72, -68],
            [126, -31],
            [52, -38],
            [31, -100],
            [62, -16],
            [32, -44],
            [6, -134],
            [-58, -44],
            [-57, -42],
            [-131, -42],
            [-100, -98],
            [-135, -19],
            [-170, 25],
            [-120, 1],
            [-82, -8],
            [-67, -85],
            [-101, -53],
            [-115, -157],
            [-91, -109],
            [67, 19],
            [128, 156],
            [167, 99],
            [119, 12],
            [70, -58],
            [-75, -80],
            [25, -128],
            [26, -89],
            [104, -60],
            [131, 17],
            [80, 134],
            [6, -86],
            [51, -43],
            [-98, -78],
            [-177, -70],
            [-79, -48],
            [-89, -86],
            [-60, 9],
            [-3, 100],
            [138, 98],
            [-127, -4],
            [-89, -14],
        ],
        [
            [5239, 15268],
            [-39, -56],
            [177, 36],
            [110, -60],
            [90, 61],
            [73, -39],
            [65, -117],
            [40, 50],
            [-56, 121],
            [70, 17],
            [79, -19],
            [89, -47],
            [50, -116],
            [25, -84],
            [133, -58],
            [144, -56],
            [-9, -53],
            [-130, -9],
            [50, -46],
            [-27, -43],
            [-144, 18],
            [-136, 32],
            [-93, -7],
            [-149, -40],
            [-202, -18],
            [-142, -11],
            [-43, 56],
            [-108, 32],
            [-71, -13],
            [-98, 94],
            [53, 13],
            [123, 20],
            [112, -6],
            [104, 21],
            [-154, 28],
            [-170, -10],
            [-113, 3],
            [-42, 44],
            [185, 47],
            [-123, -2],
            [-139, 32],
            [67, 88],
            [55, 48],
            [213, 72],
            [81, -23],
        ],
        [
            [6009, 15303],
            [-70, -78],
            [-124, 83],
            [27, 17],
            [106, 4],
            [61, -26],
        ],
        [
            [8250, 15266],
            [7, -33],
            [-85, 3],
            [-85, 3],
            [-88, -16],
            [-23, 7],
            [-87, 63],
            [3, 43],
            [39, 8],
            [182, -13],
            [137, -65],
        ],
        [
            [7436, 15272],
            [63, -74],
            [74, 96],
            [201, 49],
            [137, -123],
            [-12, -78],
            [157, 35],
            [76, 47],
            [176, -60],
            [110, -57],
            [10, -51],
            [148, 26],
            [83, -75],
            [192, -47],
            [69, -48],
            [76, -111],
            [-146, -55],
            [187, -78],
            [126, -26],
            [115, -109],
            [125, -7],
            [-25, -84],
            [-140, -137],
            [-97, 50],
            [-126, 114],
            [-103, -15],
            [-10, -68],
            [84, -68],
            [108, -55],
            [33, -32],
            [52, -117],
            [-28, -85],
            [-100, 32],
            [-200, 95],
            [113, -102],
            [83, -72],
            [13, -41],
            [-216, 47],
            [-171, 69],
            [-96, 58],
            [27, 33],
            [-118, 61],
            [-116, 58],
            [1, -35],
            [-230, -19],
            [-67, 41],
            [52, 87],
            [150, 2],
            [163, 16],
            [-26, 42],
            [28, 59],
            [102, 116],
            [-21, 52],
            [-31, 41],
            [-122, 57],
            [-161, 41],
            [51, 30],
            [-85, 73],
            [-70, 7],
            [-62, 40],
            [-43, -35],
            [-144, -15],
            [-290, 27],
            [-168, 35],
            [-129, 17],
            [-67, 42],
            [84, 54],
            [-113, 1],
            [-26, 120],
            [62, 106],
            [81, 48],
            [206, 32],
            [-59, -77],
        ],
        [
            [6339, 15354],
            [94, -25],
            [142, 15],
            [21, -35],
            [-74, -57],
            [120, -51],
            [-14, -106],
            [-131, -46],
            [-76, 10],
            [-55, 45],
            [-198, 91],
            [2, 38],
            [162, -14],
            [-88, 77],
            [95, 58],
        ],
        [
            [6908, 15226],
            [-85, -88],
            [-91, 4],
            [-49, 104],
            [1, 59],
            [41, 51],
            [79, 32],
            [166, -4],
            [152, -29],
            [-119, -106],
            [-95, -23],
        ],
        [
            [4739, 15062],
            [-210, -57],
            [-42, 52],
            [-184, 62],
            [34, 51],
            [56, 86],
            [69, 78],
            [-78, 73],
            [269, 18],
            [113, -24],
            [204, -7],
            [77, -34],
            [85, -50],
            [-100, -30],
            [-195, -83],
            [-98, -83],
            [0, -52],
        ],
        [
            [6875, 15488],
            [-43, -46],
            [-116, 9],
            [-96, 31],
            [42, 53],
            [115, 32],
            [69, -41],
            [29, -38],
        ],
        [
            [6486, 15695],
            [61, -55],
            [3, -61],
            [-37, -88],
            [-131, -12],
            [-85, 18],
            [1, 70],
            [-130, -9],
            [-5, 91],
            [85, -4],
            [120, 41],
            [112, -7],
            [6, 16],
        ],
        [
            [5713, 15633],
            [32, -42],
            [70, 20],
            [84, -5],
            [14, -58],
            [-49, -57],
            [-269, -18],
            [-201, -51],
            [-121, -3],
            [-10, 39],
            [165, 52],
            [-359, -14],
            [-112, 21],
            [109, 116],
            [75, 33],
            [224, -40],
            [141, -70],
            [139, -9],
            [-114, 113],
            [73, 43],
            [83, -13],
            [26, -57],
        ],
        [
            [6790, 15739],
            [88, -38],
            [157, 1],
            [69, -39],
            [-18, -45],
            [91, -27],
            [50, -28],
            [108, -5],
            [116, -10],
            [126, 26],
            [162, 10],
            [130, -9],
            [85, -44],
            [18, -49],
            [-50, -32],
            [-118, -25],
            [-102, 14],
            [-229, -18],
            [-163, -2],
            [-129, 14],
            [-211, 38],
            [-28, 66],
            [-9, 58],
            [-80, 52],
            [-165, 15],
            [-92, 36],
            [30, 49],
            [164, -8],
        ],
        [
            [5078, 15804],
            [-11, -91],
            [-62, -41],
            [-74, -6],
            [-148, -50],
            [-127, -19],
            [-108, 26],
            [0, 0],
            [135, 89],
            [163, 77],
            [123, -2],
            [109, 17],
        ],
        [
            [6857, 15790],
            [-36, -4],
            [-149, 8],
            [-21, 33],
            [160, -2],
            [56, -22],
            [-10, -13],
        ],
        [
            [5556, 15811],
            [-148, -35],
            [-118, 39],
            [64, 38],
            [116, 12],
            [113, -19],
            [-27, -35],
        ],
        [
            [5598, 15918],
            [-97, -23],
            [-132, 0],
            [1, 17],
            [82, 35],
            [42, -5],
            [104, -24],
        ],
        [
            [6699, 15853],
            [-118, -24],
            [-65, 27],
            [-34, 45],
            [-6, 49],
            [103, -5],
            [46, -8],
            [95, -41],
            [-21, -43],
        ],
        [
            [6362, 15885],
            [31, -49],
            [-130, 13],
            [-131, 38],
            [-177, 5],
            [77, 35],
            [-96, 28],
            [-6, 46],
            [156, -16],
            [215, -44],
            [61, -56],
        ],
        [
            [7400, 16043],
            [96, -38],
            [-109, -35],
            [-147, -89],
            [-141, -9],
            [-165, 15],
            [-86, 49],
            [2, 43],
            [62, 31],
            [-145, -1],
            [-88, 40],
            [-50, 53],
            [55, 53],
            [55, 36],
            [82, 9],
            [-35, 27],
            [185, 6],
            [102, -64],
            [134, -25],
            [130, -22],
            [63, -79],
        ],
        [
            [8874, 16452],
            [213, -9],
            [170, -15],
            [146, -33],
            [-3, -31],
            [-195, -52],
            [-192, -24],
            [-72, -26],
            [173, 0],
            [-188, -72],
            [-129, -33],
            [-136, -97],
            [-165, -20],
            [-50, -24],
            [-241, -13],
            [109, -14],
            [-55, -22],
            [66, -58],
            [-75, -41],
            [-123, -33],
            [-38, -47],
            [-111, -35],
            [11, -27],
            [136, 4],
            [2, -28],
            [-213, -72],
            [-208, 33],
            [-234, -18],
            [-118, 14],
            [-151, 6],
            [-10, 57],
            [147, 27],
            [-39, 86],
            [49, 8],
            [213, -51],
            [-109, 76],
            [-129, 23],
            [64, 45],
            [142, 29],
            [22, 41],
            [-112, 46],
            [-34, 62],
            [217, -6],
            [63, -12],
            [125, 43],
            [-180, 13],
            [-278, -7],
            [-141, 40],
            [-66, 48],
            [-93, 35],
            [-18, 40],
            [119, 23],
            [93, 4],
            [156, 19],
            [117, 44],
            [99, -6],
            [86, -33],
            [60, 64],
            [105, 19],
            [143, 13],
            [243, 5],
            [42, -13],
            [230, 20],
            [172, -7],
            [173, -8],
        ],
        [
            [15157, 12157],
            [-7, -48],
            [-35, -20],
            [-59, 14],
            [-17, -47],
            [-38, -4],
            [-14, 19],
            [-44, -41],
            [-39, -5],
            [-34, 25],
        ],
        [
            [14870, 12050],
            [-27, 52],
            [-38, -18],
            [1, 53],
            [58, 67],
            [-2, 30],
            [36, -11],
            [22, 20],
        ],
        [
            [14920, 12243],
            [67, 0],
            [17, 25],
            [85, -36],
        ],
        [
            [8996, 85],
            [-26, -48],
            [-68, -37],
            [-39, 4],
            [-47, 9],
            [-58, 36],
            [-84, 17],
            [-100, 66],
            [-81, 64],
            [-110, 133],
            [66, -25],
            [112, -79],
            [105, -43],
            [41, 55],
            [26, 81],
            [74, 49],
            [56, -14],
        ],
        [
            [8868, 393],
            [-71, 1],
            [-38, -29],
            [-72, -43],
            [-13, -111],
            [-33, -3],
            [-90, 39],
            [-91, 82],
            [0, 0],
            [-99, 68],
            [-25, 75],
            [22, 70],
            [-40, 79],
            [-10, 202],
            [34, 114],
            [84, 92],
            [-121, 34],
            [76, 105],
            [27, 197],
            [89, -42],
            [41, 246],
            [-53, 31],
            [-25, -148],
            [-50, 17],
            [25, 170],
            [27, 219],
            [36, 81],
            [-23, 116],
            [-6, 134],
            [33, 4],
            [49, 191],
            [55, 190],
            [34, 177],
            [-18, 177],
            [23, 98],
            [-9, 147],
            [46, 144],
            [15, 230],
            [25, 246],
            [25, 265],
            [-6, 194],
            [-16, 168],
        ],
        [
            [8725, 4420],
            [41, 30],
            [21, 61],
        ],
        [
            [23107, 8811],
            [-69, -57],
            [-65, 37],
            [-2, 102],
            [39, 53],
            [87, 34],
            [46, -3],
            [17, -45],
            [-35, -53],
            [-18, -68],
        ],
        [
            [20293, 11034],
            [-12, 67],
            [3, 46],
            [-49, 27],
            [-26, -12],
            [-20, 110],
        ],
        [
            [20189, 11272],
            [23, 27],
            [-11, 28],
            [76, 56],
            [55, 23],
            [84, -16],
            [30, 76],
            [102, 14],
            [28, 47],
            [126, 65],
            [11, 26],
        ],
        [
            [20713, 11618],
            [-6, 68],
            [54, 31],
            [-71, 206],
            [157, 47],
            [41, 27],
            [58, 212],
            [157, -39],
            [45, 54],
            [3, 119],
            [67, 11],
            [60, 79],
        ],
        [
            [21278, 12433],
            [31, 9],
        ],
        [
            [21309, 12442],
            [21, -82],
            [67, -63],
            [114, -45],
            [55, -95],
            [-31, -139],
            [29, -51],
            [94, -21],
            [107, -16],
            [96, -74],
            [50, -13],
            [36, -110],
            [47, -70],
            [87, 3],
            [165, -27],
            [105, 17],
            [79, -18],
            [118, -72],
            [96, 0],
            [35, -37],
            [93, 64],
            [128, 41],
            [120, 4],
            [93, 42],
            [57, 64],
            [56, 40],
            [-13, 39],
            [-26, 45],
            [42, 77],
            [45, -11],
            [82, -24],
            [79, 63],
            [121, 46],
            [59, 78],
            [56, 34],
            [115, 16],
            [63, -14],
            [9, 43],
            [-72, 82],
            [-64, 38],
            [-61, -43],
            [-79, 18],
            [-45, -15],
            [-20, 49],
            [56, 118],
            [39, 89],
        ],
        [
            [23612, 12512],
            [95, -44],
            [112, 75],
            [-1, 52],
            [72, 126],
            [45, 38],
            [-1, 65],
            [-44, 28],
            [66, 59],
            [99, 22],
            [105, 3],
            [119, -35],
            [70, -44],
            [49, -120],
            [30, -51],
            [28, -73],
            [29, -116],
            [139, -38],
            [94, -84],
            [32, -111],
            [121, -1],
            [69, 47],
            [132, 35],
            [-42, -107],
            [-31, -43],
            [-27, -130],
            [-54, -115],
            [-96, 21],
            [-69, -42],
            [21, -102],
            [-11, -140],
            [-41, -3],
            [1, -60],
        ],
        [
            [24723, 11624],
            [-52, 70],
            [-31, -67],
            [-123, -51],
            [12, -62],
            [-69, 4],
            [-37, 37],
            [-55, -84],
            [-88, -64],
            [-65, -76],
        ],
        [
            [24215, 11331],
            [-111, -34],
            [-59, -56],
            [-85, -32],
            [42, 55],
            [-17, 46],
            [63, 80],
            [-42, 62],
            [-69, -42],
            [-90, -82],
            [-49, -77],
            [-78, -6],
            [-41, -55],
            [42, -80],
            [66, -20],
            [2, -53],
            [63, -35],
            [89, 85],
            [71, -46],
            [51, -3],
            [13, -62],
            [-112, -34],
            [-37, -64],
            [-78, -59],
            [-41, -83],
            [86, -65],
            [31, -117],
            [49, -109],
            [54, -91],
            [-2, -88],
            [-50, -32],
            [19, -63],
            [47, -37],
            [-12, -97],
            [-20, -94],
            [-45, -10],
            [-58, -129],
            [-64, -156],
            [-74, -141],
            [-110, -110],
            [-110, -99],
            [-90, -14],
            [-49, -53],
            [-27, 39],
            [-45, -59],
            [-111, -59],
            [-85, -19],
            [-27, -125],
            [-44, -7],
            [-21, 86],
            [19, 46],
            [-107, 38],
            [-37, -19],
        ],
        [
            [22925, 9152],
            [-80, 31],
            [-38, 48],
            [12, 68],
            [-72, 22],
            [-39, 44],
            [-68, -63],
            [-77, -14],
            [-63, 1],
            [-43, -29],
        ],
        [
            [22457, 9260],
            [-41, -17],
            [12, -136],
            [-43, 3],
            [-7, 28],
        ],
        [
            [22378, 9138],
            [-2, 49],
            [-59, -34],
            [-34, 21],
            [-59, 45],
            [23, 98],
            [-51, 23],
            [-19, 110],
            [-84, -20],
            [10, 141],
            [75, 99],
            [4, 97],
            [-3, 91],
            [-34, 28],
            [-27, 70],
            [-47, -9],
        ],
        [
            [22071, 9947],
            [-41, 9],
            [-44, 9],
            [0, 0],
            [26, 50],
            [-37, 74],
            [0, 0],
            [-57, -50],
            [0, 0],
            [0, 0],
            [-66, 29],
            [-35, -28],
            [-57, -48],
            [-42, -50],
            [-31, -38],
            [-50, -11],
            [-14, -4],
            [0, 0],
        ],
        [
            [21394, 9833],
            [0, 0],
            [-2, 23],
            [-5, 71],
            [-30, -16],
            [-18, -9],
        ],
        [
            [21339, 9902],
            [-93, 11],
            [-90, 28],
            [-65, 52],
            [-62, 23],
            [-26, 57],
            [-45, 17],
            [-80, 77],
            [-64, 37],
            [-33, -29],
        ],
        [
            [20781, 10175],
            [0, 0],
            [-111, 83],
            [-27, 27],
            [-51, 48],
            [0, 1],
            [-22, 130],
            [16, -4],
            [3, -1],
            [38, -11],
            [2, 61],
            [-18, 35],
            [-6, 12],
            [-7, 13],
            [8, 97],
            [-86, 139],
            [0, 0],
        ],
        [
            [20520, 10805],
            [-131, 48],
            [-23, 91],
            [-59, 56],
            [-2, 6],
        ],
        [
            [14100, 7739],
            [22, -169],
            [-34, -99],
            [-21, -134],
            [35, -102],
            [-4, -47],
        ],
        [
            [14098, 7188],
            [-36, -1],
            [-56, 23],
            [-51, -1],
            [-94, -21],
            [-55, -34],
            [-79, -44],
            [-15, 3],
        ],
        [
            [13712, 7113],
            [6, 98],
            [7, 15],
            [-2, 47],
            [-34, 49],
            [-25, 8],
            [-23, 33],
            [17, 52],
            [-8, 58],
            [4, 34],
        ],
        [
            [13654, 7507],
            [12, 0],
            [5, 52],
            [-6, 23],
            [8, 16],
            [29, 15],
            [-19, 95],
            [-19, 49],
            [7, 40],
            [15, 9],
        ],
        [
            [13686, 7806],
            [11, 11],
            [22, -18],
            [61, -1],
            [15, 35],
            [14, -3],
            [23, 14],
            [12, -51],
            [19, 15],
            [32, 18],
        ],
        [
            [15600, 6865],
            [-6, -64],
            [-63, 28],
            [-64, 31],
            [-101, 4],
        ],
        [
            [15366, 6864],
            [-10, 7],
            [-47, -15],
            [-48, 16],
            [-38, -8],
        ],
        [
            [15223, 6864],
            [-130, 2],
        ],
        [
            [15093, 6866],
            [12, 94],
            [-31, 79],
            [-36, 20],
            [-17, 53],
            [-20, 17],
            [1, 33],
        ],
        [
            [15002, 7162],
            [20, 84],
            [38, 114],
            [23, 1],
            [48, 69],
            [30, 2],
            [45, -48],
            [54, 40],
            [8, 49],
            [18, 48],
            [12, 60],
            [43, 49],
            [16, 83],
            [16, 26],
            [12, 62],
            [21, 75],
            [67, 92],
            [4, 40],
            [9, 21],
            [-32, 47],
        ],
        [
            [15454, 8076],
            [3, 38],
            [22, 7],
        ],
        [
            [15479, 8121],
            [32, -76],
            [5, -79],
            [-3, -79],
            [44, -107],
            [-45, 1],
            [-22, -9],
            [-37, 12],
            [-17, -56],
            [47, -69],
            [35, -20],
            [11, -49],
            [25, -82],
            [-12, -32],
        ],
        [
            [15306, 5872],
            [-11, 37],
        ],
        [
            [15360, 6029],
            [21, -13],
            [27, 46],
            [43, -1],
            [5, -34],
            [30, -21],
            [47, 74],
            [46, 58],
            [20, 38],
            [-2, 98],
            [34, 115],
            [37, 61],
            [52, 57],
            [9, 38],
            [2, 44],
            [13, 41],
            [-4, 67],
            [10, 105],
            [16, 74],
            [23, 64],
            [5, 71],
        ],
        [
            [16504, 7216],
            [48, -98],
            [36, -14],
            [21, 20],
            [37, -8],
            [44, 25],
            [19, -50],
            [70, -79],
        ],
        [
            [16779, 7012],
            [0, 0],
            [-4, -139],
            [32, -16],
            [-26, -42],
            [-31, -32],
            [-30, -61],
            [-17, -56],
            [-4, -95],
            [-19, -45],
            [0, -89],
        ],
        [
            [16680, 6437],
            [-23, -34],
            [-3, -70],
            [-11, -9],
            [-8, -65],
        ],
        [
            [16661, 6062],
            [14, -109],
            [-8, -62],
            [16, -69],
            [46, -66],
            [43, -150],
            [0, 0],
        ],
        [
            [16772, 5606],
            [-31, 13],
            [-107, -20],
            [-22, -15],
            [-22, -75],
            [18, -53],
            [-15, -140],
            [-9, -119],
            [21, -21],
            [56, -46],
            [22, 21],
            [6, -128],
            [-61, 1],
            [-32, 66],
            [-30, 50],
            [-61, 17],
            [-18, 62],
            [-48, -38],
            [-64, 17],
            [-27, 54],
            [-50, 11],
            [-37, -3],
            [-5, 37],
            [-27, 3],
        ],
        [
            [15274, 5998],
            [-66, 126],
        ],
        [
            [15208, 6124],
            [61, 65],
            [-30, 79],
            [27, 29],
            [54, 15],
            [6, 53],
            [43, -57],
            [70, -5],
            [25, 56],
            [10, 78],
            [-9, 93],
            [-38, 70],
            [35, 138],
            [-20, 23],
            [-59, -10],
            [-23, 62],
            [6, 51],
        ],
        [
            [8763, 6086],
            [-40, 63],
            [-24, 3],
            [52, 120],
            [-61, 56],
            [-48, -10],
            [-29, 20],
            [-44, -31],
            [-59, 15],
            [-47, 124],
            [-37, 31],
            [-25, 56],
            [-53, 56],
            [-21, -11],
        ],
        [
            [8327, 6578],
            [-34, 28],
            [-39, 39],
            [-23, -19],
            [-67, 17],
            [-20, 51],
            [-15, -2],
            [-79, 67],
        ],
        [
            [8050, 6759],
            [-11, 37],
            [30, 9],
            [-4, 60],
            [19, 42],
            [39, 8],
            [34, 75],
            [30, 62],
            [-29, 28],
            [15, 69],
            [-18, 109],
            [17, 31],
            [-13, 100],
            [-32, 63],
        ],
        [
            [8127, 7452],
            [10, 58],
            [26, -9],
            [15, 36],
            [-18, 70],
            [9, 17],
        ],
        [
            [8169, 7624],
            [41, -4],
            [60, 83],
            [33, 13],
            [1, 39],
            [14, 100],
            [46, 55],
            [50, 2],
            [6, 25],
            [63, -10],
            [62, 60],
            [31, 27],
            [39, 57],
            [28, -8],
            [21, -31],
            [-16, -40],
        ],
        [
            [8648, 7992],
            [-51, -20],
            [-20, -59],
            [-31, -34],
            [-23, -44],
            [-9, -85],
            [-23, -69],
            [42, -8],
            [10, -54],
            [17, -27],
            [7, -47],
            [-10, -44],
            [3, -25],
            [20, -10],
            [18, -41],
            [103, 11],
            [46, -15],
            [56, -102],
            [32, 13],
            [58, -7],
            [45, 14],
            [28, -20],
            [-14, -64],
            [-18, -40],
            [-6, -85],
            [16, -79],
            [22, -35],
            [3, -27],
            [-40, -59],
            [29, -26],
            [21, -41],
            [24, -119],
        ],
        [
            [7723, 7571],
            [-44, 26],
            [-16, 25],
            [9, 21],
            [-2, 26],
            [-23, 29],
            [-31, 23],
            [-27, 15],
            [-6, 35],
            [-20, 21],
            [5, -35],
            [-16, -28],
            [-18, 33],
            [-26, 12],
            [-11, 24],
            [1, 36],
            [10, 37],
            [-22, 17],
            [18, 23],
        ],
        [
            [7504, 7911],
            [12, 15],
            [52, -31],
            [19, 15],
            [25, -10],
            [13, -24],
            [24, -8],
            [19, 25],
        ],
        [
            [7668, 7893],
            [20, -64],
            [31, -48],
            [37, -51],
        ],
        [
            [7756, 7730],
            [-31, -10],
            [1, -48],
            [16, -18],
            [-12, -14],
            [3, -21],
            [-6, -24],
            [-4, -24],
        ],
        [
            [7778, 9346],
            [69, -9],
            [62, -1],
            [75, -40],
            [32, -44],
            [74, 14],
            [28, -28],
            [68, -74],
            [49, -53],
            [26, 1],
            [48, -24],
            [-6, -33],
            [59, -5],
            [60, -49],
            [-9, -27],
            [-53, -15],
            [-54, -6],
            [-55, 9],
            [-114, -12],
            [54, 67],
            [-33, 30],
            [-51, 8],
            [-28, 35],
            [-19, 67],
            [-44, -4],
            [-75, 31],
            [-24, 25],
            [-103, 19],
            [-28, 23],
            [30, 29],
            [-78, 6],
            [-57, -61],
            [-33, -2],
            [-12, -29],
            [-39, -13],
            [-34, 12],
            [42, 36],
            [17, 43],
            [36, 26],
            [41, 23],
            [60, 12],
            [19, 13],
        ],
        [
            [16930, 10763],
            [6, 1],
            [12, 29],
            [57, -2],
            [72, 35],
            [-53, -50],
            [5, -22],
        ],
        [
            [17029, 10754],
            [-8, 4],
            [-15, -9],
            [-12, 2],
            [-4, -4],
            [-2, 12],
            [-6, 7],
            [-15, 1],
            [-22, -10],
            [-15, 6],
        ],
        [
            [17029, 10754],
            [3, -10],
            [-82, -48],
            [-39, 15],
            [-18, 48],
            [37, 4],
        ],
        [
            [15408, 12392],
            [-45, 51],
            [-41, 29],
            [-8, 50],
            [-14, 35],
            [57, 26],
            [30, 30],
            [57, 23],
            [20, 22],
            [21, -13],
            [36, 12],
        ],
        [
            [15521, 12657],
            [37, -38],
            [60, -11],
            [-5, -32],
            [43, -25],
            [12, 31],
            [55, -13],
            [7, -38],
            [59, -7],
            [37, -58],
        ],
        [
            [15826, 12466],
            [-24, 0],
            [-12, -22],
            [-18, -5],
            [-6, -27],
            [-15, -5],
            [-2, -11],
            [-27, -13],
            [-35, 2],
            [-12, -26],
        ],
        [
            [14920, 12243],
            [10, 85],
            [40, 81],
            [-115, 22],
            [-37, 31],
        ],
        [
            [14818, 12462],
            [4, 52],
            [-16, 27],
        ],
        [
            [14815, 12621],
            [-13, 124],
            [48, 0],
            [20, 45],
            [20, 109],
            [-15, 40],
        ],
        [
            [14875, 12939],
            [16, 25],
            [66, 6],
            [15, -26],
            [54, 59],
            [-18, 44],
            [-4, 67],
        ],
        [
            [15004, 13114],
            [60, -15],
            [51, 18],
        ],
        [
            [15115, 13117],
            [2, -46],
            [80, -28],
            [-1, -42],
            [81, 22],
            [45, 33],
            [90, -47],
            [37, -38],
        ],
        [
            [15449, 12971],
            [19, -60],
            [-22, -32],
            [29, -42],
            [19, -63],
            [-6, -41],
            [33, -76],
        ],
        [
            [17754, 8102],
            [19, -37],
            [-3, -49],
            [-45, -29],
            [34, -32],
        ],
        [
            [17759, 7955],
            [-29, -63],
        ],
        [
            [17730, 7892],
            [-18, 21],
            [-19, -9],
            [-44, 2],
            [-2, 36],
            [-6, 33],
            [27, 56],
            [28, 52],
        ],
        [
            [17696, 8083],
            [34, -10],
            [24, 29],
        ],
        [
            [15335, 13191],
            [-47, -96],
            [-84, 67],
            [-11, 49],
            [117, 39],
            [25, -59],
        ],
        [
            [15004, 13114],
            [-32, 66],
            [-3, 121],
            [14, 32],
            [22, 36],
            [71, 7],
            [27, 33],
            [65, 33],
            [-3, -61],
            [-24, -38],
            [10, -33],
            [43, -18],
            [-19, -45],
            [-24, 13],
            [-57, -86],
            [21, -57],
        ],
        [
            [8618, 8934],
            [10, 20],
            [62, -1],
            [47, -30],
            [21, 3],
            [15, -42],
            [43, 2],
            [-2, -35],
            [35, -4],
            [39, -44],
            [-29, -48],
            [-38, 26],
            [-37, -5],
            [-26, 5],
            [-14, -21],
            [-31, -8],
            [-12, 29],
            [-26, -17],
            [-32, -81],
            [-20, 19],
            [-4, 34],
        ],
        [
            [8619, 8736],
            [1, 32],
            [-20, 36],
            [19, 20],
            [6, 45],
            [-7, 65],
        ],
        [
            [15280, 9379],
            [-272, -226],
            [-231, -233],
            [-112, -53],
        ],
        [
            [14665, 8867],
            [-88, -11],
            [-1, 75],
            [-37, 20],
            [-49, 33],
            [-19, 56],
            [-269, 259],
            [-268, 259],
        ],
        [
            [13934, 9558],
            [-300, 287],
        ],
        [
            [13634, 9845],
            [2, 23],
            [0, 8],
        ],
        [
            [13636, 9876],
            [-1, 140],
            [129, 88],
            [79, 18],
            [65, 32],
            [31, 59],
            [93, 47],
            [3, 88],
            [46, 10],
            [36, 44],
            [104, 20],
            [15, 46],
            [-21, 25],
            [-27, 126],
            [-5, 72],
            [-30, 76],
        ],
        [
            [14153, 10767],
            [76, 64],
            [86, 21],
            [51, 49],
            [76, 36],
            [135, 21],
            [132, 10],
            [40, -18],
            [75, 47],
            [85, 1],
            [32, -28],
            [55, 7],
        ],
        [
            [14996, 10977],
            [-16, -60],
            [12, -113],
            [-19, -98],
            [-49, -66],
            [7, -90],
            [65, -70],
            [1, -29],
            [49, -48],
            [34, -213],
        ],
        [
            [15080, 10190],
            [26, -105],
            [4, -55],
            [-14, -96],
            [6, -55],
            [-10, -64],
            [7, -75],
            [-32, -50],
            [47, -86],
            [3, -51],
            [29, -66],
            [37, 22],
            [63, -55],
            [34, -75],
        ],
        [
            [8327, 6578],
            [11, -90],
            [-25, -78],
            [-87, -124],
            [-95, -47],
            [-49, -103],
            [-15, -80],
            [-45, -49],
            [-34, 60],
            [-32, 13],
            [-33, -9],
            [-2, 43],
            [23, 28],
            [-9, 50],
        ],
        [
            [7935, 6192],
            [42, 88],
            [-17, 52],
            [-31, -55],
            [-47, 52],
            [16, 34],
            [-14, 107],
            [28, 18],
            [15, 74],
            [30, 76],
            [-6, 49],
            [44, 25],
            [55, 47],
        ],
        [
            [17260, 9205],
            [-316, 0],
            [-309, 0],
            [-320, 0],
        ],
        [
            [16315, 9205],
            [0, 437],
            [0, 421],
            [-24, 96],
            [21, 73],
            [-13, 51],
            [29, 57],
        ],
        [
            [16328, 10340],
            [106, 2],
            [77, -32],
            [79, -35],
            [37, -18],
            [61, 37],
            [33, 34],
            [70, 10],
            [56, -15],
            [22, -59],
            [19, 39],
            [63, -28],
            [62, -7],
            [40, 30],
        ],
        [
            [17053, 10298],
            [0, 0],
            [42, -166],
        ],
        [
            [17095, 10132],
            [10, -38],
            [-22, -47],
            [-18, -90],
            [-21, -62],
            [-19, -20],
            [-26, 38],
            [-36, 53],
            [-57, 170],
            [-8, -11],
            [33, -125],
            [49, -119],
            [60, -185],
            [29, -64],
            [26, -67],
            [71, -132],
            [-16, -20],
            [3, -77],
            [93, -107],
            [14, -24],
        ],
        [
            [17696, 8083],
            [-27, 39],
            [-33, 69],
            [-35, 38],
            [-21, 41],
            [-69, 48],
            [-55, 1],
            [-19, 25],
            [-46, -28],
            [-49, 54],
            [-25, -89],
            [-92, 25],
        ],
        [
            [17225, 8306],
            [-9, 48],
            [35, 174],
            [7, 79],
            [26, 36],
            [58, 20],
            [40, 67],
        ],
        [
            [17382, 8730],
            [47, -137],
            [22, -109],
            [43, -58],
            [109, -112],
            [44, -67],
            [43, -69],
            [25, -41],
            [39, -35],
        ],
        [
            [13606, 11563],
            [4, 84],
            [-32, 52],
            [113, 85],
            [97, -21],
            [107, 1],
            [84, -21],
            [67, 7],
            [128, -4],
        ],
        [
            [14174, 11746],
            [32, -47],
            [146, -53],
            [29, 25],
            [90, -53],
            [92, 15],
        ],
        [
            [14563, 11633],
            [4, -69],
            [-75, -79],
            [-102, -25],
            [-7, -40],
            [-49, -66],
            [-31, -96],
            [31, -68],
            [-46, -53],
            [-17, -77],
            [-60, -24],
            [-56, -91],
            [-101, -2],
            [-76, 3],
            [-50, -42],
            [-30, -45],
            [-39, 10],
            [-30, 40],
            [-22, 68],
            [-75, 18],
        ],
        [
            [13732, 10995],
            [-6, 40],
            [29, 44],
            [11, 32],
            [-27, 36],
            [22, 78],
            [-32, 71],
            [34, 9],
            [3, 57],
            [13, 17],
            [1, 92],
            [37, 33],
            [-22, 59],
            [-47, 4],
            [-13, -15],
            [-47, 0],
            [-20, 58],
            [-33, -17],
            [-29, -30],
        ],
        [
            [16260, 13450],
            [10, 70],
            [-30, -15],
            [-50, 42],
            [-7, 68],
            [101, 33],
            [100, 18],
            [86, -20],
            [82, 3],
            [0, 0],
        ],
        [
            [16552, 13649],
            [0, 0],
            [12, -20],
            [-56, -69],
            [23, -110],
            [-34, -38],
        ],
        [
            [16497, 13412],
            [-65, 0],
            [-69, 44],
            [-35, 15],
            [-68, -21],
        ],
        [
            [17730, 7892],
            [-17, -42],
            [29, -66],
            [29, -57],
            [31, -42],
            [260, -141],
            [67, 1],
        ],
        [
            [18129, 7545],
            [-225, -356],
            [-104, -5],
            [-71, -84],
            [-51, -2],
            [-21, -38],
        ],
        [
            [17657, 7060],
            [-55, 0],
            [-32, 40],
            [-73, -49],
            [-23, -50],
            [-53, 10],
            [-18, 13],
            [-18, -3],
            [-26, 1],
            [-100, 101],
            [-56, 0],
            [-27, 39],
            [0, 67],
            [-41, 20],
        ],
        [
            [17135, 7249],
            [-47, 129],
            [-37, 27],
            [-14, 48],
            [-40, 57],
            [-49, 9],
            [27, 67],
            [43, 3],
            [11, 37],
            [0, 92],
        ],
        [
            [17029, 7718],
            [0, 0],
            [-1, 14],
            [24, 124],
            [38, 34],
            [8, 48],
            [34, 91],
            [48, 58],
            [32, 117],
            [13, 102],
        ],
        [
            [16601, 14787],
            [-12, -83],
            [122, -79],
            [-73, -90],
            [92, -135],
            [-53, -101],
            [71, -89],
            [-32, -77],
            [118, -81],
            [-30, -61],
            [-74, -68],
            [-171, -152],
            [0, 0],
        ],
        [
            [16559, 13771],
            [0, 0],
            [-144, -9],
            [-140, -44],
            [-129, -25],
            [-46, 65],
            [-78, 39],
            [18, 117],
            [-38, 107],
            [37, 69],
            [73, 74],
            [182, 129],
            [53, 25],
            [-8, 50],
            [-111, 56],
        ],
        [
            [16228, 14424],
            [-27, 46],
            [-2, 183],
            [-124, 81],
            [-106, 58],
        ],
        [
            [15969, 14792],
            [47, 31],
            [89, -63],
            [104, 6],
            [85, -28],
            [76, 52],
            [39, 87],
            [124, 40],
            [102, -47],
            [-34, -83],
        ],
        [
            [28522, 4539],
            [27, -34],
            [-13, -62],
            [-50, -16],
            [-43, 14],
            [-8, 52],
            [31, 41],
            [36, -14],
            [20, 19],
        ],
        [
            [28600, 4603],
            [-50, -25],
            [-11, 44],
            [40, 25],
            [25, 6],
            [47, 37],
            [0, -58],
            [-51, -29],
        ],
        [
            [7, 4638],
            [-7, -6],
            [0, 58],
            [16, 6],
            [-9, -58],
        ],
        [
            [9455, 446],
            [95, 71],
            [68, -29],
            [48, 47],
            [63, -53],
            [-23, -42],
            [-108, -35],
            [-36, 41],
            [-67, -53],
            [-40, 53],
        ],
        [
            [9986, 6870],
            [20, 50],
            [7, 54],
            [14, 51],
            [-31, 70],
            [-6, 81],
            [41, 102],
        ],
        [
            [10031, 7278],
            [27, -13],
            [59, -28],
            [84, -100],
            [13, -48],
        ],
        [
            [15086, 11595],
            [-26, -92],
            [-36, 24],
            [-18, 80],
            [16, 44],
            [51, 46],
            [13, -102],
        ],
        [
            [14777, 12470],
            [18, -10],
            [23, 2],
        ],
        [
            [14870, 12050],
            [-3, -33],
            [23, -45],
            [-27, -36],
            [20, -92],
            [43, -15],
            [-9, -51],
        ],
        [
            [14917, 11778],
            [-72, -67],
            [-157, 32],
            [-116, -39],
            [-9, -71],
        ],
        [
            [14174, 11746],
            [41, 71],
            [15, 236],
            [-82, 124],
            [-58, 60],
            [-122, 46],
            [-8, 87],
            [103, 25],
            [134, -30],
            [-25, 134],
            [75, -51],
            [185, 93],
            [24, 97],
            [70, 24],
        ],
        [
            [15208, 6124],
            [-81, 119],
            [-53, 98],
            [-48, 123],
            [2, 39],
            [18, 38],
            [19, 86],
            [16, 88],
        ],
        [
            [15081, 6715],
            [27, 7],
            [116, -1],
            [-1, 143],
        ],
        [
            [13832, 12984],
            [-60, 25],
            [-49, -2],
            [16, 64],
            [-16, 63],
        ],
        [
            [13723, 13134],
            [67, 5],
            [85, -73],
            [-43, -82],
        ],
        [
            [14086, 13550],
            [-85, -129],
            [81, 17],
            [88, -1],
            [-21, -97],
            [-72, -106],
            [83, -7],
            [6, -13],
            [71, -140],
            [54, -19],
            [49, -135],
            [23, -47],
            [96, -22],
            [-9, -76],
            [-41, -35],
            [32, -61],
            [-72, -63],
            [-106, 2],
            [-136, -33],
            [-37, 23],
            [-52, -55],
            [-74, 13],
            [-56, -45],
            [-42, 24],
            [116, 124],
            [72, 26],
            [-1, 0],
            [-124, 20],
            [-23, 47],
            [83, 37],
            [-43, 63],
            [15, 78],
            [118, -11],
            [0, 0],
            [12, 69],
            [-53, 73],
            [-1, 2],
            [-97, 21],
            [-19, 32],
            [29, 53],
            [-26, 33],
            [-43, -56],
            [-5, 114],
            [-40, 60],
            [29, 123],
            [62, 96],
            [63, -9],
            [96, 10],
        ],
        [
            [17794, 11469],
            [-77, 58],
            [-84, -5],
        ],
        [
            [17633, 11522],
            [11, 50],
            [-19, 81],
            [-46, 44],
            [-44, 14],
            [-30, 36],
        ],
        [
            [17505, 11747],
            [10, 14],
            [67, -20],
            [118, -19],
            [108, -57],
            [14, -22],
            [48, 18],
            [74, -25],
            [25, -48],
            [50, -28],
        ],
        [
            [14327, 7902],
            [-5, -37],
            [33, -61],
            [0, -86],
            [7, -93],
            [20, -44],
            [-17, -106],
            [6, -59],
            [21, -76],
            [18, -41],
        ],
        [
            [14410, 7299],
            [-125, -70],
            [-44, -40],
            [-72, -35],
            [-71, 34],
        ],
        [
            [13654, 7507],
            [-23, 3],
            [-16, -48],
            [-22, 1],
            [-16, 25],
            [5, 48],
            [-33, 73],
            [-21, -14],
            [-17, -2],
        ],
        [
            [13511, 7593],
            [-22, -7],
            [1, 43],
            [-12, 31],
            [2, 35],
            [-17, 50],
            [-22, 42],
            [-64, 0],
            [-18, -22],
            [-22, -3],
            [-14, -25],
            [-9, -33],
            [-43, -52],
        ],
        [
            [13271, 7652],
            [-35, 70],
            [-31, 46],
            [-20, 15],
            [-20, 24],
            [-9, 52],
            [-12, 27],
            [-23, 19],
        ],
        [
            [13121, 7905],
            [36, 58],
            [24, -2],
            [21, 20],
            [17, 0],
            [13, 15],
            [-7, 40],
            [9, 12],
            [1, 40],
        ],
        [
            [13235, 8088],
            [39, -1],
            [57, -29],
            [17, 3],
            [6, 13],
            [44, -9],
            [11, 6],
        ],
        [
            [13409, 8071],
            [5, -43],
            [12, 0],
            [21, 16],
            [13, -4],
            [22, -30],
            [34, -10],
            [22, 26],
            [26, 16],
            [19, 16],
            [16, -3],
            [18, -26],
            [9, -32],
            [33, -50],
            [-16, -31],
            [-4, -38],
            [17, 11],
            [10, -13],
            [-4, -36],
            [24, -34],
        ],
        [
            [12985, 8155],
            [10, 53],
        ],
        [
            [12995, 8208],
            [87, 3],
            [18, 28],
            [25, 2],
            [32, -29],
            [24, 0],
            [27, 20],
            [16, -35],
            [-35, -26],
            [-34, 2],
            [-35, 25],
            [-29, -28],
            [-14, -1],
            [-19, -16],
            [-73, 2],
        ],
        [
            [13121, 7905],
            [-42, 50],
            [-34, 7],
            [-18, 34],
            [1, 18],
            [-25, 25],
            [-5, 25],
        ],
        [
            [12998, 8064],
            [42, 20],
            [27, -4],
            [21, 13],
            [147, -5],
        ],
        [
            [15081, 6715],
            [-15, 18],
            [27, 133],
        ],
        [
            [16212, 10830],
            [43, -40],
            [62, 7],
            [59, -8],
            [-2, -21],
            [44, 14],
            [-10, -35],
            [-115, -10],
            [1, 20],
            [-97, 23],
            [15, 50],
        ],
        [
            [15998, 11440],
            [52, 10],
            [31, 26],
            [43, -2],
            [13, 20],
            [15, 4],
        ],
        [
            [16404, 11556],
            [39, -31],
            [-25, -74],
            [-19, -14],
        ],
        [
            [16399, 11437],
            [-48, 4],
            [-42, 11],
            [-96, -31],
            [55, -67],
            [-40, -19],
            [-45, 0],
            [-42, 61],
            [-15, -26],
            [18, -71],
            [40, -55],
            [-30, -26],
            [44, -55],
            [40, -34],
            [1, -67],
            [-74, 31],
            [24, -61],
            [-51, -12],
            [30, -105],
            [-53, -1],
            [-65, 51],
            [-30, 95],
            [-14, 79],
            [-31, 55],
            [-40, 67],
            [-6, 34],
        ],
        [
            [10604, 16395],
            [267, 71],
            [279, -5],
            [102, 44],
            [281, 11],
            [636, -15],
            [497, -94],
            [-146, -46],
            [-305, -5],
            [-428, -11],
            [40, -22],
            [281, 14],
            [240, -41],
            [155, 36],
            [66, -43],
            [-87, -69],
            [202, 45],
            [387, 46],
            [238, -23],
            [45, -51],
            [-325, -85],
            [-45, -27],
            [-254, -20],
            [184, -6],
            [-93, -86],
            [-64, -77],
            [3, -132],
            [95, -78],
            [-124, -5],
            [-131, -37],
            [147, -63],
            [19, -101],
            [-85, -11],
            [103, -102],
            [-177, -8],
            [92, -49],
            [-26, -41],
            [-112, -19],
            [-111, 0],
            [100, -80],
            [1, -53],
            [-158, 49],
            [-41, -32],
            [108, -30],
            [104, -72],
            [30, -96],
            [-142, -22],
            [-61, 45],
            [-98, 68],
            [27, -80],
            [-93, -62],
            [210, -6],
            [110, -6],
            [-213, -103],
            [-217, -94],
            [-233, -41],
            [-87, 0],
            [-83, -46],
            [-111, -125],
            [-171, -83],
            [-55, -5],
            [-106, -29],
            [-114, -28],
            [-68, -73],
            [-1, -83],
            [-41, -78],
            [-129, -95],
            [32, -93],
            [-36, -98],
            [-41, -116],
            [-112, -7],
            [-117, 97],
            [-160, 0],
            [-77, 66],
            [-53, 115],
            [-138, 148],
            [-40, 77],
            [-11, 107],
            [-110, 109],
            [28, 87],
            [-53, 42],
            [79, 139],
            [120, 44],
            [31, 50],
            [17, 92],
            [-91, -42],
            [-43, -17],
            [-72, -17],
            [-98, 38],
            [-5, 81],
            [31, 63],
            [74, 2],
            [163, -32],
            [-137, 76],
            [-71, 40],
            [-80, -17],
            [-66, 30],
            [89, 110],
            [-49, 45],
            [-63, 82],
            [-96, 125],
            [-101, 46],
            [1, 50],
            [-214, 69],
            [-169, 9],
            [-212, -5],
            [-194, -8],
            [-93, 37],
            [-138, 75],
            [209, 37],
            [160, 6],
            [-341, 31],
            [-179, 49],
            [11, 46],
            [301, 57],
            [292, 57],
            [31, 43],
            [-215, 43],
            [69, 47],
            [276, 83],
            [116, 12],
            [-34, 54],
            [189, 31],
            [245, 19],
            [244, 1],
            [87, -37],
            [211, 65],
            [190, -44],
            [112, -10],
            [165, -38],
            [-189, 64],
            [11, 50],
        ],
        [
            [7248, 8480],
            [26, -22],
            [7, 18],
            [23, -15],
        ],
        [
            [7304, 8461],
            [-36, -45],
            [-38, -33],
            [-6, -23],
            [7, -24],
            [-17, -30],
        ],
        [
            [7214, 8306],
            [-18, -7],
            [4, -14],
            [-15, -13],
            [-27, -30],
            [-3, -17],
        ],
        [
            [7155, 8225],
            [-41, 20],
            [-49, 2],
            [-37, 24],
            [-43, 49],
        ],
        [
            [6985, 8320],
            [2, 34],
            [10, 28],
            [-12, 22],
            [39, 97],
            [102, 0],
            [2, 41],
            [-13, 7],
            [-9, 26],
            [-29, 27],
            [-30, 40],
            [36, 0],
            [0, 67],
            [74, 0],
            [74, -1],
        ],
        [
            [9492, 7212],
            [-54, 90],
            [22, 33],
            [-2, 55],
            [49, 19],
            [20, 22],
            [-27, 44],
            [7, 43],
            [63, 70],
        ],
        [
            [9570, 7588],
            [52, -44],
            [49, -77],
            [2, -61],
            [30, -3],
            [43, -58],
            [31, -41],
        ],
        [
            [9777, 7304],
            [-12, -107],
            [-49, -31],
            [5, -28],
            [-15, -61],
            [35, -86],
            [26, 0],
            [10, -67],
            [49, -103],
        ],
        [
            [7304, 8461],
            [8, -5],
            [18, 21],
            [23, 2],
            [7, -10],
            [12, 6],
            [37, -11],
            [37, 3],
            [26, 14],
            [9, 13],
            [25, -6],
            [19, -8],
            [21, 2],
            [16, 11],
            [36, -17],
            [13, -2],
            [24, -22],
            [23, -27],
            [29, -18],
            [21, -33],
        ],
        [
            [7708, 8374],
            [-27, 3],
            [-11, -17],
            [-28, -15],
            [-20, 0],
            [-17, -15],
            [-16, 5],
            [-14, 18],
            [-8, -3],
            [-11, -29],
            [-7, 1],
            [-1, -24],
            [-28, -33],
            [-15, -14],
            [-8, -14],
            [-24, 24],
            [-17, -32],
            [-16, 1],
            [-19, -3],
            [2, -58],
            [-12, -1],
            [-10, -28],
            [-25, -4],
        ],
        [
            [7376, 8136],
            [-13, 37],
            [-25, 10],
        ],
        [
            [7338, 8183],
            [6, 48],
            [-11, 12],
            [-16, 9],
            [-35, -14],
            [-3, 16],
            [-24, 19],
            [-17, 23],
            [-24, 10],
        ],
        [
            [15803, 11654],
            [-9, -20],
        ],
        [
            [15794, 11634],
            [0, 0],
            [-75, 44],
            [-46, 42],
            [-73, 36],
            [-67, 87],
            [16, 9],
            [-36, 50],
            [-2, 40],
            [-51, 18],
            [-24, -51],
            [-24, 40],
            [2, 41],
            [3, 2],
        ],
        [
            [15417, 11992],
            [55, -4],
            [15, 20],
            [27, -19],
            [31, -3],
            [0, 33],
            [28, 13],
            [7, 47],
            [64, 32],
        ],
        [
            [15644, 12111],
            [25, -15],
            [60, -50],
            [65, -23],
            [30, 17],
        ],
        [
            [15824, 12040],
            [19, -45],
            [26, -34],
            [-31, -45],
        ],
        [
            [8619, 8736],
            [-53, 20],
            [-38, -8],
            [-48, 8],
            [-38, -22],
            [-42, 37],
            [7, 38],
            [73, -16],
            [60, -10],
            [29, 27],
            [-37, 51],
            [1, 45],
            [-50, 19],
            [18, 33],
            [48, -6],
            [69, -18],
        ],
        [
            [15677, 12303],
            [40, -30],
            [30, -13],
            [66, 14],
            [7, 24],
            [32, 4],
            [38, 18],
            [9, -8],
            [37, 15],
            [19, 28],
            [26, 7],
            [85, -36],
            [17, 13],
        ],
        [
            [16083, 12339],
            [44, -33],
            [6, -32],
        ],
        [
            [16133, 12274],
            [-49, -24],
            [-37, -81],
            [-48, -80],
            [-64, -23],
        ],
        [
            [15935, 12066],
            [-50, 6],
            [-61, -32],
            [0, 0],
        ],
        [
            [15644, 12111],
            [-16, 40],
            [-13, 1],
        ],
        [
            [23933, 5381],
            [-34, -2],
            [-105, 83],
            [74, 23],
            [42, -36],
            [28, -36],
            [-5, -32],
        ],
        [
            [24271, 5541],
            [8, -23],
            [2, -36],
        ],
        [
            [24281, 5482],
            [-52, -89],
            [-68, -26],
            [-10, 14],
            [7, 40],
            [35, 73],
            [78, 47],
        ],
        [
            [23709, 5635],
            [28, -31],
            [50, 10],
            [19, -51],
            [-92, -24],
            [-55, -16],
            [-43, 1],
            [28, 69],
            [43, 1],
            [22, 41],
        ],
        [
            [24107, 5636],
            [-12, -66],
            [-119, -34],
            [-106, 15],
            [0, 43],
            [63, 25],
            [50, -36],
            [53, 9],
            [71, 44],
        ],
        [
            [22970, 5792],
            [153, -12],
            [17, 49],
            [148, -57],
            [29, -77],
            [119, -22],
            [98, -70],
            [-91, -45],
            [-87, 47],
            [-72, -3],
            [-83, 9],
            [-74, 21],
            [-93, 46],
            [-58, 11],
            [-33, -15],
            [-145, 49],
            [-14, 51],
            [-73, 9],
            [55, 113],
            [96, -7],
            [65, -46],
            [33, -9],
            [10, -42],
        ],
        [
            [25048, 5859],
            [-41, -81],
            [-8, 89],
            [14, 43],
            [17, 40],
            [18, -35],
            [0, -56],
        ],
        [
            [24453, 6185],
            [-30, -39],
            [-55, 22],
            [-16, 51],
            [81, 5],
            [20, -39],
        ],
        [
            [24709, 6229],
            [29, -91],
            [-67, 49],
            [-67, 10],
            [-44, -8],
            [-56, 4],
            [19, 65],
            [99, 5],
            [87, -34],
        ],
        [
            [25547, 6287],
            [1, -386],
            [2, -387],
        ],
        [
            [25550, 5514],
            [-71, 98],
            [-81, 23],
            [-19, -33],
            [-101, -4],
            [33, 96],
            [51, 33],
            [-21, 129],
            [-38, 100],
            [-155, 100],
            [-65, 10],
            [-120, 110],
            [-23, -58],
            [-31, -10],
            [-18, 43],
            [0, 52],
            [-61, 58],
            [86, 43],
            [57, -2],
            [-7, 31],
            [-117, 0],
            [-31, 71],
            [-71, 22],
            [-34, 58],
            [107, 29],
            [41, 39],
            [128, -49],
            [12, -44],
            [23, -192],
            [82, -71],
            [67, 126],
            [91, 72],
            [71, 0],
            [68, -42],
            [59, -42],
            [85, -23],
        ],
        [
            [24293, 6764],
            [-64, -118],
            [-60, -22],
            [-76, 23],
            [-133, -6],
            [-70, -17],
            [-11, -90],
            [71, -105],
            [43, 53],
            [149, 41],
            [-7, -55],
            [-35, 17],
            [-34, -69],
            [-70, -46],
            [75, -152],
            [-14, -41],
            [71, -137],
            [0, -78],
            [-43, -35],
            [-31, 42],
            [38, 97],
            [-78, -46],
            [-20, 33],
            [11, 46],
            [-58, 69],
            [6, 116],
            [-53, -36],
            [7, -138],
            [3, -170],
            [-50, -17],
            [-35, 35],
            [23, 109],
            [-12, 114],
            [-34, 1],
            [-24, 81],
            [33, 78],
            [11, 94],
            [40, 179],
            [17, 49],
            [67, 88],
            [62, -35],
            [101, -17],
            [91, 5],
            [79, 87],
            [14, -27],
        ],
        [
            [24567, 6730],
            [-4, -104],
            [-41, 12],
            [-12, -72],
            [33, -63],
            [-23, -14],
            [-32, 75],
            [-23, 152],
            [16, 94],
            [26, 44],
            [6, -65],
            [47, -11],
            [7, -48],
        ],
        [
            [23053, 6834],
            [13, -80],
            [55, -67],
            [51, 24],
            [51, -8],
            [46, 60],
            [39, 10],
            [75, -33],
            [65, 25],
            [41, 165],
            [30, 41],
            [28, 135],
            [91, 0],
            [69, -20],
        ],
        [
            [23707, 7086],
            [-45, -107],
            [59, -112],
            [-14, -55],
            [89, -109],
            [-94, -14],
            [-27, -81],
            [4, -108],
            [-77, -81],
            [-2, -118],
            [-31, -181],
            [-11, 42],
            [-91, -53],
            [-31, 72],
            [-57, 7],
            [-40, 38],
            [-94, -43],
            [-29, 57],
            [-53, -6],
            [-65, 14],
            [-12, 159],
            [-40, 33],
            [-38, 101],
            [-11, 104],
            [9, 110],
            [47, 79],
        ],
        [
            [22747, 5902],
            [-88, -3],
            [-67, 99],
            [-102, 97],
            [-34, 72],
            [-61, 97],
            [-39, 88],
            [-61, 166],
            [-69, 99],
            [-24, 102],
            [-29, 93],
            [-72, 75],
            [-42, 101],
            [-59, 66],
            [-84, 131],
            [-6, 61],
            [51, -5],
            [123, -23],
            [70, -116],
            [62, -81],
            [44, -49],
            [75, -127],
            [81, -2],
            [67, -82],
            [46, -99],
            [61, -54],
            [-32, -97],
            [45, -41],
            [29, -3],
            [13, -83],
            [28, -66],
            [59, -10],
            [38, -76],
            [-20, -147],
            [-3, -183],
        ],
        [
            [13832, 12984],
            [13, -84],
            [-60, -106],
            [-141, -70],
            [-113, 18],
            [65, 123],
            [-42, 121],
            [109, 93],
            [60, 55],
        ],
        [
            [19170, 10133],
            [40, -62],
            [32, -72],
            [76, -52],
            [2, -104],
            [38, -19],
            [7, -55],
            [-115, -61],
            [-30, -138],
        ],
        [
            [19220, 9570],
            [-150, 36],
            [-87, 27],
            [-89, 15],
            [-34, 146],
            [-39, 21],
            [-61, -21],
            [-80, -58],
            [-97, 40],
            [-81, 91],
            [-76, 34],
            [-53, 112],
            [-59, 158],
            [-43, -19],
            [-50, 39],
            [-30, -46],
        ],
        [
            [18191, 10145],
            [-44, 62],
            [-1, 63],
            [-25, 0],
            [13, 86],
            [-41, 90],
            [-98, 65],
            [-55, 113],
            [18, 93],
            [41, 41],
            [-6, 69],
            [-53, 36],
            [-51, 141],
        ],
        [
            [17889, 11004],
            [0, 0],
            [-44, 95],
            [16, 37],
            [-25, 136],
            [54, 34],
        ],
        [
            [18216, 11140],
            [25, -87],
            [76, -25],
            [55, -59],
            [113, -21],
            [124, 32],
            [8, 27],
        ],
        [
            [18617, 11007],
            [70, 23],
            [56, 68],
            [54, -3],
            [35, 22],
            [56, -11],
            [88, -60],
            [64, -13],
            [91, -105],
            [59, -4],
            [7, -100],
        ],
        [
            [18191, 10145],
            [-47, 6],
        ],
        [
            [18144, 10151],
            [-54, 10],
            [-58, -114],
        ],
        [
            [18032, 10047],
            [-148, 9],
            [-225, 239],
            [-118, 83],
            [-96, 32],
        ],
        [
            [17445, 10410],
            [-32, 144],
        ],
        [
            [17413, 10554],
            [176, 124],
            [30, 143],
            [-7, 87],
            [43, 29],
            [41, 74],
        ],
        [
            [17696, 11011],
            [34, 19],
            [93, -16],
            [28, -30],
            [38, 20],
        ],
        [
            [13171, 14477],
            [-19, -76],
            [90, -81],
            [-103, -91],
            [-230, -81],
            [-68, -22],
            [-105, 18],
            [-222, 37],
            [78, 53],
            [-173, 58],
            [141, 23],
            [-3, 35],
            [-168, 27],
            [54, 77],
            [121, 18],
            [124, -80],
            [121, 64],
            [100, -33],
            [130, 63],
            [132, -9],
        ],
        [
            [17053, 10298],
            [0, 0],
            [23, 39],
            [-6, 7],
            [21, 55],
            [16, 90],
            [12, 30],
            [2, 1],
        ],
        [
            [17121, 10520],
            [27, 0],
            [7, 21],
            [21, 1],
        ],
        [
            [17176, 10542],
            [2, -48],
            [-11, -18],
            [1, -1],
        ],
        [
            [17168, 10475],
            [-14, -37],
        ],
        [
            [17154, 10438],
            [-28, 16],
            [-17, -79],
            [20, -13],
            [-20, -17],
            [-4, -31],
            [38, 16],
        ],
        [
            [17143, 10330],
            [2, -46],
            [-40, -190],
        ],
        [
            [17105, 10094],
            [-10, 38],
        ],
        [
            [15561, 11130],
            [-29, -93],
            [12, -37],
            [-17, -61],
            [-61, 44],
            [-40, 13],
            [-111, 61],
            [11, 60],
            [93, -10],
            [81, 13],
            [61, 10],
        ],
        [
            [15058, 11483],
            [48, -84],
            [-11, -157],
            [-36, 8],
            [-33, -40],
            [-30, 31],
            [-3, 144],
            [-18, 67],
            [44, -6],
            [39, 37],
        ],
        [
            [15424, 12112],
            [-8, -59],
            [19, -50],
        ],
        [
            [15435, 12003],
            [-64, 17],
            [-64, -42],
            [4, -59],
            [-10, -34],
            [26, -60],
            [75, -60],
            [40, -98],
            [89, -95],
            [62, 0],
            [19, -26],
            [-22, -24],
            [71, -42],
            [59, -36],
            [68, -62],
            [8, -22],
            [-15, -43],
            [-44, 56],
            [-69, 19],
            [-33, -77],
            [57, -44],
            [-9, -61],
            [-34, -8],
            [-42, -101],
            [-33, -9],
            [0, 36],
            [16, 64],
            [18, 25],
            [-32, 69],
            [-24, 59],
            [-33, 15],
            [-23, 51],
            [-51, 22],
            [-35, 48],
            [-59, 7],
            [-62, 54],
            [-73, 77],
            [-54, 68],
            [-25, 118],
            [-39, 13],
            [-65, 39],
            [-37, -16],
            [-46, -55],
            [-33, -8],
        ],
        [
            [8152, 8789],
            [54, -11],
            [42, -29],
            [13, -32],
            [-56, -2],
            [-24, -20],
            [-45, 19],
            [-45, 43],
            [9, 27],
            [34, 9],
            [18, -4],
        ],
        [
            [17445, 10410],
            [-15, -18],
            [-160, -59],
            [80, -119],
            [-27, -20],
            [-13, -40],
            [-60, -16],
            [-20, -43],
            [-34, -37],
            [-88, 19],
        ],
        [
            [17108, 10077],
            [-3, 17],
        ],
        [
            [17143, 10330],
            [11, 35],
            [0, 73],
        ],
        [
            [17168, 10475],
            [89, -47],
            [156, 126],
        ],
        [
            [25041, 10646],
            [10, -41],
            [-45, -72],
            [-32, 38],
            [-41, -27],
            [-21, -70],
            [-52, 34],
            [0, 56],
            [44, 71],
            [46, -14],
            [32, 50],
            [59, -25],
        ],
        [
            [25545, 11001],
            [-30, -95],
            [14, -59],
            [-41, -84],
            [-102, -56],
            [-140, -7],
            [-113, -135],
            [-54, 45],
            [-3, 89],
            [-138, -26],
            [-95, -56],
            [-93, -3],
            [81, -87],
            [-53, -201],
            [-52, -50],
            [-38, 46],
            [19, 107],
            [-50, 34],
            [-32, 82],
            [75, 36],
            [42, 75],
            [80, 61],
            [58, 81],
            [158, 35],
            [86, -24],
            [83, 211],
            [53, -57],
            [117, 119],
            [45, 46],
            [50, 145],
            [-14, 133],
            [34, 75],
            [85, 22],
            [43, -164],
            [-2, -97],
            [-74, -119],
            [1, -122],
        ],
        [
            [25779, 11835],
            [56, -26],
            [56, 51],
            [18, -133],
            [-118, -33],
            [-70, -118],
            [-125, 81],
            [-44, -129],
            [-88, -2],
            [-11, 118],
            [39, 91],
            [85, 7],
            [24, 164],
            [23, 92],
            [94, -123],
            [61, -40],
        ],
        [
            [20713, 11618],
            [-49, 18],
            [-40, 42],
            [-118, 13],
            [-132, 3],
            [-29, -13],
            [-113, 50],
            [-45, -25],
            [-13, -70],
            [-131, 41],
            [-52, -17],
            [-18, -52],
        ],
        [
            [19973, 11608],
            [-46, -22],
            [-104, -82],
            [-35, -85],
            [-30, -1],
            [-22, 56],
            [-101, 4],
            [-16, 97],
            [-39, 1],
            [6, 119],
            [-95, 87],
            [-137, -9],
            [-93, -18],
            [-76, 107],
            [-65, 45],
            [-124, 85],
            [-14, 10],
            [-205, -70],
            [3, -437],
        ],
        [
            [18780, 11495],
            [-41, -6],
            [-56, 93],
            [-54, 33],
            [-90, -24],
            [-35, -40],
        ],
        [
            [18504, 11551],
            [-4, 29],
            [19, 49],
            [-15, 42],
            [-92, 40],
            [-36, 107],
            [-44, 30],
            [-3, 38],
            [78, -11],
            [3, 87],
            [67, 19],
            [70, -18],
            [14, 116],
            [-14, 73],
            [-80, -5],
            [-67, 29],
            [-92, -53],
            [-75, -24],
        ],
        [
            [18233, 12099],
            [-40, 19],
            [8, 61],
            [-51, 79],
            [-59, -3],
            [-67, 80],
            [46, 90],
            [-24, 24],
            [64, 131],
            [82, -69],
            [10, 86],
            [164, 129],
            [124, 3],
            [176, -82],
            [94, -48],
            [84, 50],
            [126, 3],
            [102, -62],
            [23, 36],
            [112, -6],
            [20, 57],
            [-129, 81],
            [76, 58],
            [-14, 32],
            [76, 31],
            [-57, 81],
            [36, 41],
            [298, 41],
            [39, 29],
            [199, 44],
            [71, 49],
            [143, -25],
            [25, -123],
            [84, 29],
            [102, -41],
            [-7, -64],
            [76, 6],
            [200, 112],
            [-29, -37],
            [101, -92],
            [178, -301],
            [43, 62],
            [109, -68],
            [115, 30],
            [44, -21],
            [38, -68],
            [56, -23],
            [33, -51],
            [103, 16],
            [42, -72],
        ],
        [
            [17657, 7060],
            [-70, -134],
            [1, -432],
            [47, -98],
        ],
        [
            [17635, 6396],
            [-56, -47],
            [-19, -50],
            [-30, -9],
            [-11, -83],
            [-26, -48],
            [-16, -79],
            [-32, -39],
        ],
        [
            [17445, 6041],
            [-114, 119],
            [-5, 68],
            [-289, 242],
            [-13, 13],
        ],
        [
            [17024, 6483],
            [-1, 126],
            [23, 48],
            [39, 78],
            [29, 87],
            [-35, 136],
            [-9, 59],
            [-38, 83],
        ],
        [
            [17032, 7100],
            [49, 70],
            [54, 79],
        ],
        [
            [20189, 11272],
            [-150, -18],
            [-99, 39],
            [-86, -9],
            [7, 68],
            [87, -20],
            [29, 37],
        ],
        [
            [19977, 11369],
            [61, -12],
            [102, 85],
            [-95, 63],
            [-56, -30],
            [-59, 45],
            [67, 77],
            [-24, 11],
        ],
        [
            [22490, 8041],
            [-19, 143],
            [51, 99],
            [103, 22],
            [74, -17],
        ],
        [
            [22699, 8288],
            [66, -46],
            [36, 82],
            [71, -44],
        ],
        [
            [22872, 8280],
            [18, -79],
            [-10, -142],
            [-133, -91],
            [34, -72],
            [-83, -9],
            [-69, -48],
        ],
        [
            [22629, 7839],
            [-67, 18],
            [-32, 61],
            [-40, 123],
        ],
        [
            [24540, 11175],
            [69, -140],
            [20, -77],
            [0, -136],
            [-30, -66],
            [-72, -22],
            [-63, -50],
            [-72, -10],
            [-9, 65],
            [15, 89],
            [-35, 123],
            [59, 20],
            [-55, 102],
        ],
        [
            [24367, 11073],
            [5, 11],
            [36, -5],
            [31, 54],
            [56, 6],
            [34, 7],
            [11, 29],
        ],
        [
            [15923, 11647],
            [15, 26],
        ],
        [
            [15938, 11673],
            [19, 9],
            [11, 39],
            [14, 7],
            [11, -17],
            [15, -7],
            [11, -19],
            [13, -6],
            [15, -22],
            [11, 1],
            [-8, -29],
            [-10, -14],
            [3, -9],
        ],
        [
            [16043, 11606],
            [-18, -5],
            [-47, -18],
            [-4, -24],
            [-10, 1],
        ],
        [
            [18144, 10151],
            [16, -53],
            [-7, -27],
            [26, -89],
        ],
        [
            [18179, 9982],
            [-57, -3],
            [-19, 56],
            [-71, 12],
        ],
        [
            [22457, 9260],
            [46, -94],
            [36, -107],
            [98, -1],
            [31, -104],
            [-51, -31],
            [-23, -43],
            [96, -70],
            [66, -141],
            [50, -104],
            [60, -83],
            [20, -83],
            [-14, -119],
        ],
        [
            [22699, 8288],
            [26, 54],
            [4, 100],
            [-65, 104],
            [-4, 117],
            [-61, 96],
            [-60, 8],
            [-16, -41],
            [-47, -4],
            [-24, 21],
            [-84, -70],
            [-1, 106],
            [19, 125],
            [-54, 5],
            [-4, 72],
            [-35, 36],
        ],
        [
            [22293, 9017],
            [17, 44],
            [68, 77],
        ],
        [
            [17121, 10520],
            [28, 97],
            [40, 83],
            [1, 5],
        ],
        [
            [17190, 10705],
            [36, -7],
            [13, -46],
            [-43, -45],
            [-20, -65],
        ],
        [
            [13712, 7113],
            [-21, -1],
            [-82, 57],
            [-72, 90],
            [-68, 65],
            [-54, 76],
        ],
        [
            [13415, 7400],
            [19, 38],
            [4, 35],
            [36, 64],
            [37, 56],
        ],
        [
            [15080, 10190],
            [39, 28],
            [7, 50],
            [-9, 49],
            [55, 46],
            [25, 38],
            [38, 34],
            [5, 91],
        ],
        [
            [15240, 10526],
            [93, -41],
            [34, 10],
            [66, -20],
            [106, -53],
            [37, -105],
            [72, -23],
            [112, -50],
            [85, -59],
            [38, 31],
            [38, 55],
            [-18, 90],
            [25, 58],
            [57, 56],
            [55, 16],
            [108, -24],
            [27, -53],
            [29, -1],
            [26, -20],
            [79, -14],
            [19, -39],
        ],
        [
            [16315, 9205],
            [0, -237],
            [-91, 0],
            [-1, -50],
        ],
        [
            [16223, 8918],
            [-318, 227],
            [-317, 227],
            [-81, -65],
        ],
        [
            [15507, 9307],
            [-56, -44],
            [-45, 65],
            [-126, 51],
        ],
        [
            [20835, 7488],
            [-12, -124],
            [-34, -33],
            [-69, -28],
            [-38, 95],
            [-14, 170],
            [36, 193],
            [55, -66],
            [37, -84],
            [39, -123],
        ],
        [
            [16632, 3161],
            [27, -35],
            [-24, -58],
            [-14, -39],
            [-44, -18],
            [-15, -38],
            [-28, -12],
            [-60, 91],
            [43, 75],
            [43, 47],
            [37, 24],
            [35, -37],
        ],
        [
            [16195, 12990],
            [-20, 36],
            [-40, 13],
        ],
        [
            [16135, 13039],
            [-7, 30],
            [9, 33],
            [-35, 18],
            [-84, 21],
        ],
        [
            [16018, 13141],
            [-17, 100],
        ],
        [
            [16001, 13241],
            [91, 36],
            [134, -7],
            [78, 11],
            [11, -24],
            [43, -8],
            [76, -57],
        ],
        [
            [16001, 13241],
            [3, 89],
            [39, 75],
            [75, 40],
            [63, -88],
            [64, 2],
            [15, 91],
        ],
        [
            [16497, 13412],
            [39, -27],
            [6, -58],
            [26, -70],
        ],
        [
            [13636, 9876],
            [-12, 0],
            [0, 0],
            [2, -64],
            [-50, -4],
            [-25, -27],
            [-36, 0],
            [-29, 16],
            [-67, -13],
            [-26, -92],
            [-25, -9],
            [-37, -150],
            [-111, -128],
            [-26, -163],
            [-33, -54],
            [-9, -42],
            [-180, -10],
            [-1, 0],
        ],
        [
            [12971, 9136],
            [4, 55],
            [30, 33],
            [26, 61],
            [-5, 41],
            [28, 83],
            [44, 76],
            [27, 19],
            [21, 69],
            [2, 63],
            [28, 73],
            [53, 44],
            [51, 121],
            [1, 1],
            [40, 46],
            [74, 13],
            [63, 81],
            [40, 32],
            [66, 99],
            [-20, 147],
            [31, 102],
            [10, 63],
            [51, 80],
            [80, 54],
            [59, 49],
            [54, 123],
            [25, 73],
            [58, -1],
            [48, -50],
            [76, 8],
            [82, -26],
            [35, -1],
        ],
        [
            [16444, 12315],
            [19, 17],
            [53, 12],
            [59, -37],
            [32, -5],
            [36, -31],
            [-5, -41],
            [29, -19],
            [11, -50],
            [28, -30],
            [-6, -17],
            [15, -12],
            [-21, -9],
            [-47, 3],
            [-8, 17],
            [-16, -10],
            [5, -21],
            [-22, -38],
            [-13, -41],
            [-21, -12],
        ],
        [
            [16572, 11991],
            [-14, 54],
            [9, 50],
            [-3, 52],
            [-46, 71],
            [-25, 50],
            [-25, 35],
            [-24, 12],
        ],
        [
            [18268, 5117],
            [22, -51],
            [19, -78],
            [13, -143],
            [21, -55],
            [-8, -57],
            [-14, -35],
            [-27, 69],
            [-15, -35],
            [15, -87],
            [-7, -51],
            [-22, -27],
            [-5, -101],
            [-31, -138],
            [-40, -163],
            [-49, -225],
            [-30, -165],
            [-36, -137],
            [-65, -29],
            [-70, -50],
            [-45, 31],
            [-64, 42],
            [-22, 63],
            [-5, 105],
            [-28, 94],
            [-7, 86],
            [14, 85],
            [37, 21],
            [0, 39],
            [38, 90],
            [7, 76],
            [-18, 56],
            [-15, 74],
            [-7, 110],
            [28, 66],
            [11, 75],
            [39, 5],
            [45, 24],
            [29, 21],
            [35, 2],
            [46, 68],
            [65, 73],
            [24, 59],
            [-11, 51],
            [34, -14],
            [44, 82],
            [1, 72],
            [27, 53],
            [27, -51],
        ],
        [
            [6985, 8320],
            [-90, 128],
            [-41, 38],
            [-65, 31],
            [-44, -9],
            [-64, -44],
            [-40, -12],
            [-56, 31],
            [-60, 23],
            [-74, 54],
            [-60, 17],
            [-90, 55],
            [-67, 57],
            [-20, 31],
            [-44, 8],
            [-82, 37],
            [-33, 54],
            [-85, 68],
            [-40, 74],
            [-19, 58],
            [26, 12],
            [-8, 34],
            [18, 30],
            [1, 41],
            [-27, 54],
            [-7, 47],
            [-27, 60],
            [-70, 117],
            [-80, 93],
            [-39, 74],
            [-68, 48],
            [-15, 29],
            [12, 74],
            [-40, 27],
            [-47, 58],
            [-20, 83],
            [-43, 9],
            [-46, 63],
            [-37, 58],
            [-4, 37],
            [-43, 89],
            [-28, 91],
            [1, 46],
            [-57, 47],
            [-27, -6],
            [-45, 33],
            [-13, -48],
            [13, -57],
            [8, -89],
            [27, -49],
            [59, -82],
            [14, -28],
            [12, -8],
            [10, -41],
            [14, 2],
            [16, -77],
            [24, -30],
            [17, -42],
            [50, -60],
            [27, -110],
            [23, -52],
            [23, -56],
            [4, -63],
            [38, -3],
            [32, -54],
            [29, -53],
            [-2, -22],
            [-33, -43],
            [-14, 0],
            [-21, 73],
            [-53, 67],
            [-57, 57],
            [-41, 31],
            [3, 86],
            [-12, 65],
            [-38, 36],
            [-55, 53],
            [-10, -15],
            [-20, 31],
            [-49, 29],
            [-47, 69],
            [6, 9],
            [32, -7],
            [30, 44],
            [3, 54],
            [-61, 84],
            [-47, 33],
            [-30, 74],
            [-29, 78],
            [-37, 95],
            [-32, 106],
        ],
        [
            [5004, 10454],
            [90, 9],
            [101, 13],
            [-7, -23],
            [120, -58],
            [182, -83],
            [158, 1],
            [63, 0],
            [0, 49],
            [138, 0],
            [29, -42],
            [41, -38],
            [47, -52],
            [26, -62],
            [20, -65],
            [41, -36],
            [66, -36],
            [51, 94],
            [65, 2],
            [56, -47],
            [40, -81],
            [27, -70],
            [47, -67],
            [18, -83],
            [22, -56],
            [62, -37],
            [56, -26],
        ],
        [
            [6563, 9660],
            [32, 4],
            [-31, -104],
            [-14, -86],
            [-6, -159],
            [-8, -57],
            [14, -65],
            [25, -58],
            [16, -92],
            [52, -88],
            [19, -68],
            [31, -58],
            [85, -32],
            [33, -49],
            [69, 33],
            [61, 12],
            [60, 21],
            [50, 20],
            [50, 49],
            [19, 69],
            [7, 100],
            [14, 34],
            [53, 31],
            [85, 28],
            [70, -4],
            [48, 10],
            [19, -25],
            [-2, -58],
            [-43, -70],
            [-19, -72],
            [15, -21],
            [-12, -51],
            [-20, -93],
            [-20, 31],
            [-17, -2],
        ],
        [
            [16043, 11606],
            [27, 7],
            [37, 2],
        ],
        [
            [13409, 8071],
            [4, 37],
            [-7, 46],
            [-30, 33],
            [-15, 68],
            [-4, 74],
        ],
        [
            [13357, 8329],
            [27, 22],
            [13, 70],
            [25, 2],
            [56, -33],
            [45, 24],
            [30, -8],
            [12, 26],
            [320, 2],
            [17, 83],
            [-13, 15],
            [-39, 512],
            [-38, 511],
            [122, 3],
        ],
        [
            [14665, 8867],
            [0, -273],
            [-43, -79],
            [-7, -73],
            [-71, -19],
            [-108, -10],
            [-30, -42],
            [-51, -5],
        ],
        [
            [21701, 9210],
            [13, 9],
            [26, 19],
            [-8, 50],
            [1, 2],
            [17, 39],
            [2, 95],
            [1, 27],
            [17, -7],
            [45, -20],
            [0, 0],
            [15, 42],
            [21, 56],
            [4, 58],
            [11, 25],
            [33, 74],
            [-2, 41],
            [-1, 27],
            [42, 34],
            [61, 48],
            [57, -21],
            [0, 0],
            [-7, 73],
            [14, 11],
            [14, 11],
            [-6, 44],
        ],
        [
            [22293, 9017],
            [-45, -27],
            [-47, -52],
            [-56, -5],
            [-36, -128],
            [-34, -22],
            [39, -104],
            [50, -86],
            [33, -79],
            [-29, -103],
            [-28, -22],
            [19, -59],
            [53, -94],
            [9, -67],
            [-1, -55],
            [31, -108],
            [-43, -110],
            [-39, -122],
        ],
        [
            [22169, 7774],
            [-8, 88],
            [25, 91],
            [-27, 70],
            [6, 129],
            [-32, 61],
            [-26, 142],
            [-14, 150],
            [-35, 98],
            [-52, -59],
            [-90, -85],
            [-45, 11],
            [-49, 28],
            [27, 147],
            [-17, 111],
            [-62, 136],
            [10, 43],
            [-47, 15],
            [-56, 97],
        ],
        [
            [15867, 11562],
            [-16, 10],
            [-23, 38],
            [-34, 24],
        ],
        [
            [15855, 11758],
            [21, -21],
            [12, -16],
            [26, -13],
            [30, -25],
            [-6, -10],
        ],
        [
            [21309, 12442],
            [84, 21],
            [152, 102],
            [121, 56],
            [69, -37],
            [83, -1],
            [54, -56],
            [79, -4],
            [115, -30],
            [77, 83],
            [-32, 70],
            [83, 122],
            [89, -49],
            [72, -13],
            [93, -31],
            [16, -89],
            [113, -50],
            [75, 22],
            [101, 16],
            [79, -16],
            [78, -57],
            [49, -60],
            [73, 1],
            [101, -20],
            [73, 30],
            [105, 20],
            [116, 83],
            [48, -13],
            [42, -39],
            [95, 9],
        ],
        [
            [17076, 5229],
            [60, 10],
            [96, -34],
            [20, 15],
            [56, 4],
            [28, 35],
            [48, -2],
            [87, 46],
            [63, 69],
            [0, 0],
        ],
        [
            [17534, 5372],
            [0, 0],
            [13, -53],
            [-3, -118],
            [10, -104],
            [3, -186],
            [14, -58],
            [-24, -85],
            [-31, -82],
            [-51, -73],
            [-72, -46],
            [-90, -57],
            [-90, -127],
            [-31, -22],
            [-55, -84],
            [-33, -28],
            [-7, -84],
            [38, -90],
            [16, -70],
            [1, -35],
            [14, 6],
            [-2, -117],
            [-13, -55],
            [18, -20],
            [-11, -49],
            [-34, -43],
            [-65, -40],
            [-96, -64],
            [-35, -44],
            [7, -50],
            [20, -8],
            [-7, -62],
        ],
        [
            [16938, 3424],
            [-60, 1],
        ],
        [
            [16878, 3425],
            [-7, 52],
            [-12, 54],
        ],
        [
            [16859, 3531],
            [-6, 42],
            [14, 132],
            [-21, 85],
            [-38, 167],
        ],
        [
            [16808, 3957],
            [84, 134],
            [21, 86],
            [12, 11],
            [9, 69],
            [-13, 35],
            [3, 89],
            [16, 82],
            [0, 150],
            [-42, 38],
            [-38, 9],
            [-17, 29],
            [-37, 25],
            [-66, -2],
            [-5, 44],
        ],
        [
            [16735, 4756],
            [-8, 85],
            [242, 98],
        ],
        [
            [16969, 4939],
            [46, -57],
            [22, 11],
            [31, -31],
            [5, -47],
            [-17, -55],
            [6, -84],
            [52, -73],
            [24, 82],
            [34, 25],
            [-6, 153],
            [-34, 86],
            [-28, 38],
            [-28, -2],
            [-22, 154],
            [22, 90],
        ],
        [
            [13357, 8329],
            [-53, 82],
            [-48, 87],
            [-53, 31],
            [-38, 35],
            [-44, -1],
            [-39, -26],
            [-39, 10],
            [-28, -38],
        ],
        [
            [13015, 8509],
            [-7, 64],
            [23, 59],
            [9, 111],
            [-8, 118],
            [-10, 58],
            [8, 60],
            [-21, 56],
            [-42, 51],
        ],
        [
            [12967, 9086],
            [18, 40],
            [312, -1],
            [-16, 171],
            [20, 61],
            [74, 11],
            [-2, 303],
            [261, -6],
            [0, 180],
        ],
        [
            [16969, 4939],
            [-42, 30],
            [24, 110],
            [25, 42],
            [-15, 98],
            [16, 96],
            [13, 32],
            [-20, 101],
            [-37, 53],
        ],
        [
            [16933, 5501],
            [78, -22],
            [16, -33],
            [27, -55],
            [22, -162],
        ],
        [
            [22455, 7334],
            [18, -12],
            [47, -71],
            [33, -80],
            [5, -79],
            [-9, -54],
            [8, -41],
            [6, -70],
            [28, -33],
            [31, -105],
            [-1, -40],
            [-57, -8],
            [-75, 88],
            [-94, 94],
            [-10, 60],
            [-46, 80],
            [-11, 98],
            [-28, 65],
            [8, 86],
            [-17, 50],
        ],
        [
            [22291, 7362],
            [14, 21],
            [65, -51],
            [6, -61],
            [53, 14],
            [26, 49],
        ],
        [
            [23514, 7242],
            [61, 82],
            [40, 93],
            [32, 0],
            [41, -60],
            [4, -51],
            [52, -33],
            [67, -36],
            [-6, -46],
            [-53, -6],
            [14, -58],
            [-59, -41],
        ],
        [
            [23053, 6834],
            [58, -41],
            [62, 22],
            [16, 101],
            [34, 22],
            [95, 26],
            [57, 93],
            [40, 75],
        ],
        [
            [16173, 4517],
            [65, 27],
            [52, -7],
            [31, -26],
            [1, -10],
        ],
        [
            [15909, 3658],
            [0, -438],
            [-71, -61],
            [-43, -8],
            [-50, 22],
            [-36, 9],
            [-13, 51],
            [-32, 32],
            [-38, -59],
        ],
        [
            [15626, 3206],
            [-59, 90],
            [-31, 87],
            [-18, 115],
            [-19, 86],
            [-27, 183],
            [-2, 142],
            [-10, 64],
            [-31, 49],
            [-41, 98],
            [-42, 142],
            [-17, 75],
            [-65, 116],
            [-5, 91],
        ],
        [
            [27519, 4096],
            [66, -74],
            [41, -55],
            [-30, -28],
            [-44, 32],
            [-57, 53],
            [-51, 63],
            [-53, 84],
            [-11, 40],
            [34, -2],
            [45, -40],
            [35, -40],
            [25, -33],
        ],
        [
            [15507, 9307],
            [20, -184],
            [30, -31],
            [1, -38],
            [33, -40],
            [-17, -51],
            [-31, -241],
            [-4, -154],
            [-102, -112],
            [-34, -156],
            [33, -44],
            [0, -77],
            [51, -2],
            [-8, -56],
        ],
        [
            [15454, 8076],
            [-15, -2],
            [-54, 129],
            [-18, 5],
            [-62, -66],
            [-62, 34],
            [-43, 7],
            [-23, -16],
            [-47, 3],
            [-46, -50],
            [-41, -3],
            [-96, 61],
            [-38, -29],
            [-41, 2],
            [-30, 45],
            [-79, 44],
            [-86, -14],
            [-21, -26],
            [-11, -68],
            [-23, -48],
            [-5, -105],
        ],
        [
            [15002, 7162],
            [-83, -43],
            [-30, 6],
            [-30, -26],
            [-64, 2],
            [-43, 74],
            [-26, 86],
            [-56, 78],
            [-60, -1],
            [-70, 0],
        ],
        [
            [7504, 7911],
            [-28, 37],
            [-37, 48],
            [-17, 40],
            [-34, 37],
            [-40, 54],
            [9, 18],
            [13, -18],
            [6, 9],
        ],
        [
            [7708, 8374],
            [-7, -11],
            [-4, -27],
            [8, -43],
            [-18, -41],
            [-9, -47],
            [-2, -53],
            [4, -30],
            [2, -53],
            [-12, -12],
            [-7, -51],
            [5, -31],
            [-16, -31],
            [3, -32],
            [13, -19],
        ],
        [
            [14589, 12685],
            [41, 33],
            [70, 174],
            [109, 50],
            [66, -3],
        ],
        [
            [15969, 14792],
            [-50, -5],
            [-11, -78],
            [-150, 19],
            [-22, -66],
            [-76, 0],
            [-52, -84],
            [-80, -132],
            [-124, -167],
            [29, -40],
            [-27, -47],
            [-79, 2],
            [-52, -111],
            [5, -158],
            [51, -60],
            [-27, -139],
            [-66, -82],
            [-35, -68],
        ],
        [
            [15203, 13576],
            [-53, 73],
            [-157, -137],
            [-107, -28],
            [-110, 60],
            [-28, 128],
            [-25, 273],
            [73, 77],
            [210, 99],
            [157, 123],
            [146, 165],
            [191, 229],
            [134, 89],
            [218, 149],
            [175, 52],
            [131, -6],
            [121, 98],
            [145, -5],
            [143, 23],
            [249, -87],
            [-102, -31],
            [87, -75],
        ],
        [
            [16801, 14845],
            [-136, -47],
            [-64, -11],
        ],
        [
            [16293, 15829],
            [-178, -48],
            [-140, 27],
            [55, 31],
            [-48, 38],
            [165, 23],
            [31, -44],
            [115, -27],
        ],
        [
            [15778, 16048],
            [262, -88],
            [-200, -47],
            [-44, -87],
            [-70, -22],
            [-38, -99],
            [-96, -4],
            [-171, 72],
            [72, 42],
            [-119, 34],
            [-155, 101],
            [-62, 92],
            [217, 43],
            [43, -42],
            [114, 2],
            [30, 41],
            [117, 4],
            [100, -42],
        ],
        [
            [16351, 16132],
            [156, -42],
            [-118, -64],
            [-231, -13],
            [-235, 19],
            [-14, 33],
            [-114, 2],
            [-87, 55],
            [246, 33],
            [115, -29],
            [81, 36],
            [201, -30],
        ],
        [
            [21339, 9902],
            [0, 0],
            [0, 0],
            [-1, -6],
            [-5, -45],
            [10, -76],
            [-9, -47],
            [0, 0],
            [-66, -2],
            [-96, 28],
            [-46, 9],
            [-16, 2],
            [-46, 61],
            [-109, 15],
            [-103, 67],
            [-2, 1],
            [-73, 57],
            [-78, 45],
            [31, 111],
            [51, 53],
            [0, 0],
        ],
        [
            [28096, 1743],
            [18, -49],
            [56, 48],
            [23, -50],
            [0, -50],
            [-29, -55],
            [-52, -88],
            [-41, -47],
            [29, -57],
            [-61, -2],
            [-68, -45],
            [-22, -77],
            [-45, -120],
            [-62, -53],
            [-40, -34],
            [-73, 2],
            [-52, 40],
            [-86, 8],
            [-14, 43],
            [43, 88],
            [100, 117],
            [52, 23],
            [57, 45],
            [68, 62],
            [48, 62],
            [35, 88],
            [30, 30],
            [12, 66],
            [56, 55],
            [18, -50],
        ],
        [
            [28222, 2307],
            [58, -124],
            [2, 81],
            [35, -33],
            [12, -89],
            [64, -39],
            [54, -10],
            [46, 46],
            [40, -14],
            [-19, -105],
            [-25, -70],
            [-60, 3],
            [-22, -36],
            [8, -51],
            [-12, -22],
            [-30, -64],
            [-39, -81],
            [-62, -48],
            [-14, 31],
            [-33, 18],
            [46, 97],
            [-26, 65],
            [-86, 48],
            [3, 43],
            [57, 41],
            [14, 91],
            [-4, 77],
            [-32, 80],
            [2, 21],
            [-38, 49],
            [-63, 104],
            [-33, 84],
            [29, 10],
            [44, -66],
            [62, -31],
            [22, -106],
        ],
        [
            [18814, 9552],
            [36, -81],
            [44, -43],
            [58, -16],
            [48, -21],
            [35, -68],
            [22, -40],
            [28, -15],
            [0, -26],
            [-29, -71],
            [-12, -33],
            [-34, -38],
            [-30, -81],
            [-36, 6],
            [-16, -29],
            [-13, -60],
            [10, -79],
            [-8, -15],
            [-36, 1],
            [-50, -44],
            [-8, -58],
            [-18, -25],
            [-50, 1],
            [-31, -30],
            [1, -48],
            [-39, -33],
            [-44, 11],
            [-53, -40],
            [-37, -7],
        ],
        [
            [18552, 8570],
            [-26, 83],
            [-62, 196],
        ],
        [
            [18464, 8849],
            [239, 119],
            [53, 237],
            [-37, 84],
        ],
        [
            [18788, 9686],
            [23, 40],
            [10, -10],
            [-8, -49],
            [-10, -22],
        ],
        [
            [20153, 10954],
            [-18, -6],
            [-40, -95],
            [96, -47],
            [24, -59],
            [-40, -60],
            [24, -178],
            [52, -27],
            [0, 0],
            [64, -59],
            [-19, -19],
            [-49, -50],
            [1, -84],
            [-77, -119],
            [-20, -49],
            [-30, -72],
            [-83, -124],
            [-16, 2],
            [-76, 7],
            [-44, -62],
            [-44, -62],
            [52, -53],
            [9, -92],
            [15, -19],
            [30, -41],
            [16, -102],
            [-176, 1],
            [0, 0],
            [0, 0],
            [-53, -79],
        ],
        [
            [19751, 9406],
            [-58, 29],
            [-24, 86],
            [-61, 90],
            [-147, -22],
            [-129, -2],
            [-112, -17],
        ],
        [
            [8127, 7452],
            [-26, 35],
            [-17, 64],
            [19, 31],
            [-20, 8],
            [-15, 40],
            [-39, 33],
            [-35, -8],
            [-16, -41],
            [-32, -30],
            [-18, -4],
            [-8, -25],
            [38, -64],
            [-21, -15],
            [-12, -18],
            [-37, -6],
            [-14, 71],
            [-10, -20],
            [-26, 7],
            [-16, 47],
            [-33, 8],
            [-21, 14],
            [-34, 0],
            [-2, -26],
            [-9, 18],
        ],
        [
            [7756, 7730],
            [29, -42],
            [-2, -26],
            [32, -5],
            [7, 10],
            [22, -29],
            [39, 8],
            [34, 30],
            [48, 24],
            [28, 36],
            [44, -7],
            [-3, -12],
            [44, -4],
            [35, -21],
            [26, -35],
            [30, -33],
        ],
        [
            [8725, 4420],
            [-80, 68],
            [-7, 48],
            [-158, 119],
            [-142, 130],
            [-62, 73],
            [-33, 98],
            [13, 34],
            [-67, 156],
            [-79, 219],
            [-75, 236],
            [-32, 54],
            [-25, 87],
            [-62, 78],
            [-57, 48],
            [26, 53],
            [-39, 113],
            [25, 83],
            [64, 75],
        ],
        [
            [24383, 7594],
            [8, -79],
            [5, -67],
            [-27, -108],
            [-29, 121],
            [-37, -61],
            [25, -87],
            [-23, -55],
            [-93, 68],
            [-23, 86],
            [25, 57],
            [-51, 56],
            [-25, -50],
            [-37, 5],
            [-59, -66],
            [-13, 35],
            [31, 100],
            [50, 33],
            [43, 45],
            [29, -54],
            [60, 32],
            [13, 53],
            [56, 3],
            [-4, 92],
            [64, -56],
            [7, -60],
            [5, -43],
        ],
        [
            [24193, 7815],
            [-29, -39],
            [-25, -75],
            [-25, -35],
            [-49, 82],
            [17, 31],
            [20, 34],
            [8, 73],
            [44, 7],
            [-13, -80],
            [59, 115],
            [-7, -113],
        ],
        [
            [23757, 7701],
            [-106, -113],
            [39, 83],
            [57, 73],
            [48, 82],
            [42, 118],
            [14, -97],
            [-52, -65],
            [-42, -81],
        ],
        [
            [24026, 8006],
            [48, -37],
            [50, 0],
            [-1, -49],
            [-37, -50],
            [-51, -36],
            [-3, 55],
            [6, 61],
            [-12, 56],
        ],
        [
            [24314, 8038],
            [22, -132],
            [-61, 31],
            [1, -40],
            [20, -73],
            [-38, -26],
            [-3, 83],
            [-24, 6],
            [-13, 72],
            [47, -9],
            [-1, 44],
            [-49, 91],
            [77, -3],
            [22, -44],
        ],
        [
            [23997, 8146],
            [-21, -103],
            [-34, 59],
            [-40, 91],
            [68, -5],
            [27, -42],
        ],
        [
            [23981, 8790],
            [49, -34],
            [25, 31],
            [7, -30],
            [-13, -49],
            [27, -85],
            [-21, -99],
            [-47, -39],
            [-12, -96],
            [17, -94],
            [43, -13],
            [35, 14],
            [99, -66],
            [-7, -64],
            [26, -29],
            [-9, -55],
            [-62, 59],
            [-29, 62],
            [-21, -44],
            [-50, 71],
            [-73, -17],
            [-39, 26],
            [4, 49],
            [25, 30],
            [-24, 28],
            [-10, -43],
            [-40, 68],
            [-11, 52],
            [-3, 113],
            [32, -39],
            [8, 186],
            [26, 107],
            [48, 0],
        ],
        [
            [26731, 5787],
            [-22, -12],
            [-34, 45],
            [-35, 76],
            [-17, 90],
            [11, 12],
            [8, -36],
            [24, -27],
            [39, -75],
            [38, -40],
            [-12, -33],
        ],
        [
            [26421, 5946],
            [-41, -10],
            [-13, -33],
            [-44, -29],
            [-40, -28],
            [-43, 0],
            [-65, 35],
            [-45, 33],
            [6, 37],
            [72, -18],
            [43, 10],
            [12, 57],
            [12, 2],
            [7, -63],
            [46, 10],
            [22, 40],
            [45, 42],
            [-9, 70],
            [47, 3],
            [17, -20],
            [-2, -66],
            [-27, -72],
        ],
        [
            [25547, 6287],
            [138, -81],
            [147, -68],
            [55, -61],
            [45, -60],
            [12, -70],
            [132, -73],
            [20, -63],
            [-74, -13],
            [18, -79],
            [71, -77],
            [52, -126],
            [45, 4],
            [-3, -53],
            [61, -20],
            [-23, -22],
            [84, -50],
            [-9, -35],
            [-52, -8],
            [-20, 31],
            [-68, 13],
            [-81, 18],
            [-62, 76],
            [-45, 65],
            [-41, 104],
            [-104, 52],
            [-67, -34],
            [-49, -39],
            [10, -88],
            [-62, -41],
            [-45, 20],
            [-82, 5],
        ],
        [
            [26513, 6062],
            [-25, -32],
            [-15, 70],
            [-18, 46],
            [-36, 39],
            [-45, 51],
            [-58, 34],
            [22, 29],
            [43, -33],
            [27, -26],
            [34, -29],
            [32, -49],
            [30, -38],
            [9, -62],
        ],
        [
            [16198, 12713],
            [40, -104],
            [-9, -33],
            [-39, -14],
            [-72, -98],
            [20, -54],
            [-17, 7],
        ],
        [
            [16121, 12417],
            [-76, 46],
            [-57, -17],
            [-38, 12],
            [-47, -25],
            [-40, 42],
            [-33, -16],
            [-4, 7],
        ],
        [
            [15449, 12971],
            [55, 35],
            [124, 55],
            [100, 40],
            [79, -20],
            [6, -29],
            [77, -1],
        ],
        [
            [15890, 13051],
            [98, -14],
            [147, 2],
        ],
        [
            [9050, 8791],
            [41, -10],
            [14, -24],
            [-20, -29],
            [-60, 0],
            [-46, -4],
            [-5, 51],
            [11, 17],
            [65, -1],
        ],
        [
            [24723, 11624],
            [0, 0],
            [11, -21],
        ],
        [
            [24734, 11603],
            [-30, 7],
            [-35, -40],
            [-24, -40],
            [3, -86],
            [-41, -26],
            [-14, -21],
            [-30, -35],
            [-53, -19],
            [-35, -32],
            [-2, -52],
            [-9, -13],
            [31, -19],
            [45, -52],
        ],
        [
            [24367, 11073],
            [-38, 22],
            [-10, -22],
            [-23, -10],
            [-3, 23],
            [-21, 10],
            [-21, 19],
            [22, 52],
            [18, 14],
            [-7, 22],
            [21, 64],
            [-6, 19],
            [-46, 13],
            [-38, 32],
        ],
        [
            [13732, 10995],
            [-32, -30],
            [-42, 16],
            [-41, -13],
            [12, 93],
            [-7, 73],
            [-36, 11],
            [-19, 45],
            [7, 78],
            [31, 43],
            [6, 48],
            [17, 71],
            [-2, 50],
            [-16, 43],
            [-4, 40],
        ],
        [
            [18369, 9532],
            [-5, 86],
            [21, 62],
            [22, 13],
            [24, -37],
            [2, -70],
            [-18, -70],
        ],
        [
            [18415, 9516],
            [-22, -8],
            [-24, 24],
        ],
        [
            [16129, 11842],
            [-15, 21],
            [19, 20],
            [-20, 14],
            [-25, -26],
            [-46, 34],
            [-7, 49],
            [-48, 28],
            [-9, 38],
            [-43, 46],
        ],
        [
            [16133, 12274],
            [34, 26],
            [50, -13],
            [51, -1],
            [37, -29],
            [27, 19],
            [58, 11],
            [20, 28],
            [34, 0],
        ],
        [
            [16572, 11991],
            [36, -22],
            [37, 19],
            [37, -21],
        ],
        [
            [16682, 11967],
            [1, -30],
            [-38, -26],
            [-24, 11],
            [-23, -143],
        ],
        [
            [25758, 12614],
            [80, -210],
            [-118, 39],
            [-49, -171],
            [78, -122],
            [-2, -82],
            [-61, 71],
            [-52, -92],
            [-15, 100],
            [9, 115],
            [-9, 128],
            [19, 90],
            [3, 159],
            [-47, 116],
            [7, 162],
            [74, 55],
            [-32, 55],
            [36, 16],
            [21, -78],
            [27, -114],
            [-2, -117],
            [33, -120],
        ],
        [
            [15890, 13051],
            [18, 52],
            [110, 38],
        ],
        [
            [397, 14493],
            [53, -30],
            [-18, 86],
            [216, -17],
            [156, -111],
            [-79, -52],
            [-131, -12],
            [-1, -116],
            [-32, -25],
            [-75, 4],
            [-61, 41],
            [-105, 35],
            [-18, 51],
            [-81, 19],
            [-90, -15],
            [-44, 41],
            [18, 45],
            [-96, -29],
            [36, -55],
            [-45, -51],
            [0, 473],
            [195, -91],
            [209, -118],
            [-7, -73],
        ],
        [
            [28651, 14996],
            [-87, -6],
            [-14, 38],
            [101, 49],
            [0, -81],
        ],
        [
            [104, 15004],
            [-104, -8],
            [0, 81],
            [10, 5],
            [68, 0],
            [115, -34],
            [-7, -16],
            [-82, -28],
        ],
        [
            [25754, 15279],
            [-120, -1],
            [-163, 13],
            [-14, 6],
            [75, 47],
            [100, 11],
            [113, -45],
            [9, -31],
        ],
        [
            [26322, 15501],
            [-92, -47],
            [-128, 10],
            [-147, 47],
            [19, 39],
            [148, -18],
            [200, -31],
        ],
        [
            [25872, 15557],
            [-62, -88],
            [-294, 4],
            [-132, -28],
            [-157, 77],
            [43, 81],
            [105, 23],
            [210, -6],
            [287, -63],
        ],
        [
            [18905, 14983],
            [-47, -10],
            [-261, 15],
            [-21, 53],
            [-144, 32],
            [-11, 64],
            [81, 25],
            [-3, 65],
            [158, 101],
            [-73, 14],
            [191, 104],
            [-22, 54],
            [178, 63],
            [263, 76],
            [265, 22],
            [136, 44],
            [155, 16],
            [55, -47],
            [-53, -37],
            [-282, -59],
            [-243, -56],
            [-248, -113],
            [-118, -116],
            [-125, -114],
            [16, -99],
            [153, -97],
        ],
        [
            [17505, 11747],
            [-101, 100],
            [-91, 45],
            [-69, 70],
            [58, 19],
            [66, 99],
            [-44, 47],
            [117, 48],
            [-2, 26],
            [-71, -19],
        ],
        [
            [17368, 12182],
            [2, 53],
            [41, 33],
            [77, 8],
            [13, 40],
            [-18, 65],
            [32, 63],
            [-1, 34],
            [-117, 39],
            [-46, -1],
            [-49, 55],
            [-62, -19],
            [-101, 42],
            [2, 23],
            [-28, 52],
            [-64, 6],
            [-6, 36],
            [20, 24],
            [-51, 68],
            [-83, -12],
            [-24, 6],
            [-20, -27],
            [-30, 5],
        ],
        [
            [16552, 13649],
            [91, 66],
            [-84, 56],
        ],
        [
            [16801, 14845],
            [0, 0],
            [82, 42],
            [131, -72],
            [218, -28],
            [300, -135],
            [61, -56],
            [6, -79],
            [-89, -62],
            [-130, -32],
            [-355, 90],
            [-58, -15],
            [129, -87],
            [5, -55],
            [6, -121],
            [102, -36],
            [62, -31],
            [10, 58],
            [-47, 51],
            [50, 45],
            [193, -74],
            [67, 29],
            [-54, 87],
            [186, 116],
            [73, -7],
            [74, -42],
            [47, 82],
            [-67, 71],
            [39, 71],
            [-58, 73],
            [222, -38],
            [46, -66],
            [-101, -15],
            [1, -66],
            [62, -41],
            [123, 26],
            [20, 76],
            [166, 56],
            [278, 102],
            [60, -6],
            [-79, -72],
            [99, -12],
            [57, 40],
            [149, 4],
            [118, 49],
            [91, -72],
            [90, 79],
            [-83, 69],
            [41, 39],
            [236, -36],
            [110, -37],
            [288, -136],
            [53, 62],
            [-81, 63],
            [-2, 25],
            [-96, 12],
            [26, 56],
            [-42, 93],
            [-3, 38],
            [147, 107],
            [53, 108],
            [59, 23],
            [210, -31],
            [17, -66],
            [-75, -96],
            [49, -38],
            [26, -83],
            [-18, -162],
            [87, -73],
            [-34, -79],
            [-156, -169],
            [91, -17],
            [32, 42],
            [88, 31],
            [21, 59],
            [69, 56],
            [-47, 67],
            [37, 79],
            [-87, 10],
            [-19, 66],
            [64, 119],
            [-104, 96],
            [143, 80],
            [-19, 85],
            [40, 2],
            [42, -65],
            [-32, -115],
            [86, -22],
            [-37, 86],
            [134, 47],
            [165, 6],
            [147, -68],
            [-71, 99],
            [-8, 126],
            [138, 24],
            [192, -5],
            [172, 16],
            [-64, 62],
            [92, 77],
            [91, 4],
            [155, 59],
            [210, 15],
            [27, 33],
            [209, 11],
            [65, -27],
            [178, 63],
            [147, -2],
            [22, 52],
            [76, 50],
            [187, 49],
            [137, -39],
            [-108, -29],
            [180, -18],
            [21, -59],
            [73, 29],
            [233, -2],
            [179, -57],
            [64, -45],
            [-20, -61],
            [-88, -36],
            [-209, -65],
            [-60, -36],
            [99, -16],
            [118, -30],
            [71, 22],
            [41, -76],
            [35, 31],
            [127, 19],
            [255, -20],
            [20, -55],
            [333, -18],
            [4, 91],
            [169, -21],
            [127, 1],
            [129, -63],
            [36, -76],
            [-47, -49],
            [100, -94],
            [125, -48],
            [77, 124],
            [128, -53],
            [135, 32],
            [154, -36],
            [59, 33],
            [130, -17],
            [-57, 110],
            [105, 52],
            [719, -77],
            [67, -71],
            [209, -90],
            [321, 22],
            [159, -20],
            [66, -49],
            [-10, -86],
            [98, -34],
            [107, 24],
            [141, 3],
            [150, -23],
            [151, 13],
            [139, -105],
            [98, 38],
            [-64, 75],
            [35, 53],
            [254, -33],
            [166, 7],
            [229, -56],
            [111, -52],
            [0, -473],
            [-1, 0],
            [-102, -52],
            [-103, 8],
            [72, -63],
            [47, -98],
            [37, -32],
            [9, -49],
            [-20, -31],
            [-149, 26],
            [-222, -90],
            [-71, -13],
            [-122, -84],
            [-115, -72],
            [-30, -54],
            [-113, 82],
            [-208, -93],
            [-36, 44],
            [-77, -51],
            [-106, 16],
            [-26, -78],
            [-95, -115],
            [3, -48],
            [90, -26],
            [-10, -173],
            [-74, -4],
            [-34, -99],
            [33, -52],
            [-139, -60],
            [-28, -136],
            [-119, -28],
            [-23, -121],
            [-115, -110],
            [-30, 81],
            [-34, 173],
            [-44, 264],
            [38, 164],
            [67, 71],
            [4, 56],
            [124, 26],
            [142, 149],
            [137, 122],
            [143, 95],
            [64, 167],
            [-96, -10],
            [-48, -98],
            [-202, -130],
            [-65, 146],
            [-206, -40],
            [-199, -199],
            [66, -73],
            [-178, -31],
            [-123, -12],
            [6, 86],
            [-124, 18],
            [-98, -58],
            [-244, 20],
            [-262, -35],
            [-257, -232],
            [-305, -279],
            [125, -15],
            [39, -75],
            [77, -26],
            [51, 59],
            [88, -7],
            [115, -131],
            [2, -101],
            [-62, -118],
            [-7, -142],
            [-36, -190],
            [-119, -171],
            [-27, -82],
            [-108, -138],
            [-107, -137],
            [-52, -70],
            [-106, -70],
            [-50, -1],
            [-50, 57],
            [-107, -87],
            [-12, -39],
        ],
        [
            [18233, 12099],
            [-36, -71],
            [-77, -19],
            [-79, -123],
            [72, -112],
            [-8, -80],
            [87, -140],
            [0, 0],
        ],
        [
            [22688, 15883],
            [-449, -46],
            [146, 156],
            [65, 13],
            [60, -8],
            [202, -67],
            [-24, -48],
        ],
        [
            [18395, 16149],
            [-107, -16],
            [-71, -9],
            [-11, -20],
            [-93, -19],
            [-87, 28],
            [46, 37],
            [-177, 4],
            [155, 21],
            [121, 2],
            [16, -32],
            [46, 28],
            [75, 20],
            [118, -26],
            [-31, -18],
        ],
        [
            [22279, 15951],
            [-173, -15],
            [-222, 34],
            [-132, 46],
            [-61, 85],
            [-109, 23],
            [207, 81],
            [172, 27],
            [155, -60],
            [183, -114],
            [-20, -107],
        ],
        [
            [16680, 6437],
            [19, -13],
            [47, 37],
        ],
        [
            [16746, 6461],
            [32, -67],
            [-5, -70],
            [-23, -15],
            [0, 0],
        ],
        [
            [12967, 9086],
            [4, 50],
        ],
        [
            [18464, 8849],
            [-229, -45],
            [-75, -54],
            [-57, -124],
            [-37, -20],
            [-20, 39],
            [-30, -6],
            [-77, 12],
            [-15, 12],
            [-92, -3],
            [-21, -10],
            [-33, 31],
            [-21, -59],
            [8, -50],
            [-35, -38],
        ],
        [
            [17730, 8534],
            [-10, 51],
            [-24, 36],
            [-6, 47],
            [-41, 43],
            [-43, 99],
            [-22, 97],
            [-55, 81],
            [-36, 20],
            [-53, 113],
            [-9, 82],
            [4, 71],
            [-46, 131],
            [-37, 46],
            [-43, 25],
            [-26, 68],
            [4, 27],
            [-22, 61],
            [-23, 27],
            [-32, 88],
            [-48, 95],
            [-41, 82],
            [-39, -1],
            [12, 65],
            [4, 42],
            [10, 47],
        ],
        [
            [18179, 9982],
            [31, -102],
            [39, -27],
            [14, -42],
            [54, -50],
            [5, -49],
            [-8, -39],
            [10, -40],
            [23, -33],
            [10, -39],
            [12, -29],
        ],
        [
            [18415, 9516],
            [16, -45],
        ],
        [
            [17029, 7718],
            [-12, 2],
            [2, 59],
            [-10, 41],
            [-41, 47],
            [-9, 86],
            [9, 87],
            [-37, 8],
            [-5, -26],
            [-48, -6],
            [19, -35],
            [7, -71],
            [-44, -65],
            [-39, -86],
            [-41, -12],
            [-67, 69],
            [-30, -24],
            [-8, -35],
            [-41, -22],
            [-3, -25],
            [-79, 0],
            [-11, 25],
            [-58, 4],
            [-28, -21],
            [-22, 11],
            [-41, 69],
            [-14, 32],
            [-57, -16],
            [-22, -55],
            [-21, -106],
            [-27, -22],
            [-24, -13],
        ],
        [
            [16145, 7917],
            [1, 29],
            [-29, 35],
            [-1, 69],
            [-17, 45],
            [-28, -6],
            [8, 43],
            [21, 50],
            [-9, 49],
            [26, 36],
            [-16, 28],
            [21, 73],
            [36, 87],
            [69, -8],
            [-4, 471],
        ],
        [
            [17260, 9205],
            [25, -117],
            [-17, -21],
            [11, -122],
            [30, -142],
            [30, -29],
            [43, -44],
        ],
        [
            [17032, 7100],
            [-49, -55],
            [-56, 0],
            [-64, -27],
            [-51, 26],
            [-33, -32],
        ],
        [
            [12998, 8064],
            [-13, 91],
        ],
        [
            [12995, 8208],
            [-33, 92],
            [-39, 43],
            [35, 22],
            [38, 83],
            [19, 61],
        ],
        [
            [27228, 5352],
            [22, -40],
            [-55, 0],
            [-31, 73],
            [48, -28],
            [16, -5],
        ],
        [
            [27127, 5425],
            [-31, -3],
            [-49, 12],
            [-16, 18],
            [5, 47],
            [52, -18],
            [26, -25],
            [13, -31],
        ],
        [
            [27193, 5457],
            [-12, -22],
            [-59, 103],
            [-17, 71],
            [27, 0],
            [29, -95],
            [32, -57],
        ],
        [
            [27049, 5607],
            [4, -24],
            [-63, 50],
            [-43, 43],
            [-30, 39],
            [12, 12],
            [36, -28],
            [66, -55],
            [18, -37],
        ],
        [
            [26863, 5724],
            [-15, -7],
            [-35, 27],
            [-33, 49],
            [4, 20],
            [48, -50],
            [31, -39],
        ],
        [
            [13415, 7400],
            [-21, 9],
            [-58, 48],
            [-41, 64],
            [-14, 43],
            [-10, 88],
        ],
        [
            [7338, 8183],
            [-8, -28],
            [-47, 2],
            [-28, 11],
            [-33, 24],
            [-44, 7],
            [-23, 26],
        ],
        [
            [17759, 7955],
            [26, -22],
            [16, -49],
            [36, -50],
            [39, 0],
            [75, 30],
            [87, 14],
            [70, 37],
            [39, 8],
            [29, 22],
            [45, 4],
            [0, -2],
        ],
        [
            [18221, 7947],
            [-1, -49],
            [0, -120],
            [0, -61],
            [-36, -73],
            [-55, -99],
        ],
        [
            [18221, 7947],
            [0, 2],
            [26, 2],
            [36, 18],
            [42, 12],
            [38, 40],
            [30, 1],
            [2, -33],
            [-7, -69],
            [0, -62],
            [-17, -43],
            [-22, -128],
            [-39, -133],
            [-49, -151],
            [-68, -174],
            [-68, -133],
            [-94, -162],
            [-79, -96],
            [-119, -118],
            [-74, -90],
            [-88, -143],
            [-18, -63],
            [-18, -28],
        ],
        [
            [9777, 7304],
            [96, -24],
            [8, 22],
            [65, 8],
            [85, -32],
        ],
        [
            [16121, 12417],
            [-22, -31],
            [-16, -47],
        ],
        [
            [15417, 11992],
            [18, 11],
        ],
        [
            [16228, 14424],
            [-137, -33],
            [-77, -83],
            [12, -73],
            [-126, -95],
            [-154, -102],
            [-58, -167],
            [57, -84],
            [76, -66],
            [-73, -133],
            [-83, -28],
            [-30, -199],
            [-46, -111],
            [-96, 11],
            [-45, -94],
            [-92, -5],
            [-26, 112],
            [-66, 134],
            [-61, 168],
        ],
        [
            [16878, 3425],
            [-16, -53],
            [-47, -13],
            [-47, 65],
            [-1, 41],
            [22, 44],
            [7, 35],
            [23, 8],
            [40, -21],
        ],
        [
            [17190, 10705],
            [-7, 90],
            [20, 49],
        ],
        [
            [17203, 10844],
            [21, 26],
            [21, 26],
            [4, 66],
            [26, -23],
            [88, 33],
            [42, -22],
            [66, 0],
            [92, 45],
            [42, -2],
            [91, 18],
        ],
        [
            [14474, 7324],
            [-64, -25],
        ],
        [
            [22490, 8041],
            [-72, 54],
            [-68, -2],
            [12, 93],
            [-70, 0],
            [-6, -131],
            [-43, -173],
            [-26, -105],
            [5, -86],
            [52, -3],
            [32, -109],
            [15, -102],
            [44, -68],
            [48, -14],
            [42, -61],
        ],
        [
            [22291, 7362],
            [-32, 46],
            [-13, 59],
            [-42, 67],
            [-39, 56],
            [-13, -70],
            [-15, 66],
            [9, 74],
            [23, 114],
        ],
        [
            [19724, 11001],
            [45, 120],
            [-18, 88],
            [-58, 29],
            [21, 52],
            [66, -6],
            [38, 66],
            [25, 76],
            [107, 28],
            [-17, -55],
            [11, -33],
            [33, 3],
        ],
        [
            [18617, 11007],
            [-15, 84],
            [12, 124],
            [-62, 41],
            [20, 81],
            [-53, 7],
            [18, 100],
            [75, -30],
            [70, 38],
            [-58, 72],
            [-23, 67],
            [-64, -30],
            [-8, -87],
            [-25, 77],
        ],
        [
            [18780, 11495],
            [90, 1],
            [-13, 60],
            [68, 41],
            [67, 69],
            [107, -63],
            [8, -94],
            [31, -25],
            [86, 6],
            [27, -22],
            [39, -122],
            [91, -82],
            [52, -56],
            [83, -58],
            [106, -51],
            [-3, -72],
        ],
        [
            [24271, 5541],
            [10, 28],
            [68, 27],
            [56, 4],
            [25, 14],
            [30, -14],
            [-30, -32],
            [-83, -52],
            [-66, -34],
        ],
        [
            [9417, 7872],
            [45, 15],
            [17, -4],
            [-3, -88],
            [-67, -13],
            [-14, 10],
            [23, 33],
            [-1, 47],
        ],
        [
            [14996, 10977],
            [86, 48],
            [56, -14],
            [-2, -60],
            [67, 44],
            [6, -23],
            [-40, -58],
            [0, -55],
            [27, -29],
            [-10, -103],
            [-53, -60],
            [15, -64],
            [42, -2],
            [20, -57],
            [30, -18],
        ],
        [
            [17203, 10844],
            [-30, 54],
            [30, 44],
            [-48, -10],
            [-67, 28],
            [-54, -69],
            [-121, -13],
            [-65, 64],
            [-85, 4],
            [-19, -50],
            [-55, -14],
            [-77, 64],
            [-87, -3],
            [-47, 118],
            [-58, 66],
            [39, 92],
            [-51, 57],
            [89, 113],
            [122, 5],
            [34, 90],
            [151, -15],
            [96, 77],
            [93, 33],
            [131, 3],
            [139, -84],
            [114, -46],
            [93, 18],
            [69, -10],
            [94, 62],
        ],
        [
            [16554, 11578],
            [9, -46],
            [70, -38],
            [-15, -29],
            [-94, -7],
            [-34, -36],
            [-67, -64],
            [-25, 55],
            [1, 24],
        ],
        [
            [24017, 9489],
            [-48, -190],
            [-34, -98],
            [-42, 100],
            [-9, 88],
            [47, 117],
            [64, 90],
            [36, -36],
            [-14, -71],
        ],
        [
            [16746, 6461],
            [28, 14],
            [88, -1],
            [162, 9],
        ],
        [
            [17445, 6041],
            [-36, -146],
            [4, -67],
            [51, -44],
            [3, -30],
            [-22, -72],
            [4, -36],
            [-5, -57],
            [28, -74],
            [33, -117],
            [29, -26],
        ],
        [
            [16933, 5501],
            [-45, 35],
            [-51, 20],
            [-32, 20],
            [-33, 30],
        ],
        [
            [17368, 12182],
            [-64, -10],
            [-53, -38],
            [-74, -6],
            [-69, -44],
            [5, -74],
            [39, -29],
            [81, 7],
            [-16, -42],
            [-87, -20],
            [-108, -69],
            [-44, 24],
            [17, 56],
            [-87, 34],
            [14, 23],
            [77, 40],
            [-23, 27],
            [-124, 30],
            [-6, 44],
            [-73, -15],
            [-30, -65],
            [-61, -88],
        ],
        [
            [10078, 2591],
            [-35, -75],
            [-90, -66],
            [-58, 24],
            [-43, -13],
            [-74, 51],
            [-54, -4],
            [-48, 66],
        ],
        [
            [1947, 8859],
            [-12, -20],
            [-20, 17],
            [2, 33],
            [-13, 43],
            [4, 14],
            [14, 19],
            [-5, 23],
            [4, 11],
            [6, -2],
            [31, -20],
            [14, -10],
            [13, -16],
            [20, -42],
            [-2, -6],
            [-31, -26],
            [-25, -18],
        ],
        [
            [1904, 9044],
            [-27, -8],
            [-14, 24],
            [-9, 10],
            [0, 8],
            [7, 10],
            [29, -12],
            [20, -18],
            [-6, -14],
        ],
        [
            [1850, 9107],
            [-3, -13],
            [-42, 4],
            [6, 14],
            [39, -5],
        ],
        [
            [1779, 9124],
            [-5, -6],
            [-5, 1],
            [-28, 4],
            [-10, 27],
            [-3, 5],
            [21, 16],
            [7, -7],
            [23, -40],
        ],
        [
            [1644, 9203],
            [-10, -12],
            [-26, 22],
            [4, 8],
            [12, 12],
            [18, -3],
            [2, -27],
        ],
        [
            [8982, 11949],
            [14, -39],
            [-85, -57],
            [-82, -41],
            [-84, -35],
            [-42, -71],
            [-13, -27],
            [-1, -62],
            [26, -63],
            [33, -3],
            [-8, 43],
            [24, -26],
            [-7, -34],
            [-53, -19],
            [-39, 2],
            [-59, -21],
            [-34, -6],
            [-46, -6],
            [-67, -34],
            [117, 22],
            [24, -22],
            [-112, -36],
            [-50, 0],
            [2, 15],
            [-24, -33],
            [23, -6],
            [-17, -85],
            [-58, -91],
            [-6, 30],
            [-17, 7],
            [-26, 29],
            [16, -64],
            [20, -21],
            [1, -45],
            [-25, -46],
            [-45, -94],
            [-8, 4],
            [25, 81],
            [-41, 45],
            [-9, 99],
            [-15, -51],
            [17, -76],
            [-53, 19],
            [55, -38],
            [3, -113],
            [23, -8],
            [8, -41],
            [12, -119],
            [-51, -88],
            [-82, -35],
            [-53, -70],
            [-39, -7],
            [-41, -44],
            [-11, -40],
            [-87, -77],
            [-45, -56],
            [-38, -71],
            [-12, -84],
            [14, -82],
            [27, -102],
            [35, -84],
            [0, -51],
            [38, -137],
            [-2, -80],
            [-4, -46],
            [-20, -73],
            [-24, -15],
            [-39, 15],
            [-12, 52],
            [-30, 27],
            [-43, 102],
            [-37, 91],
            [-12, 46],
            [17, 79],
            [-23, 65],
            [-62, 99],
            [-31, 18],
            [-80, -54],
            [-14, 6],
            [-39, 56],
            [-50, 29],
            [-90, -15],
            [-70, 13],
            [-61, -8],
            [-33, -18],
            [14, -32],
            [-1, -48],
            [17, -23],
            [-15, -16],
            [-30, 17],
            [-30, -22],
            [-57, 4],
            [-60, 62],
            [-69, -14],
            [-58, 27],
            [-50, -8],
            [-67, -28],
            [-72, -88],
            [-79, -51],
            [-43, -57],
            [-19, -53],
            [-1, -82],
            [4, -57],
            [16, -40],
            [-32, -4],
        ],
        [
            [5004, 10454],
            [-14, 61],
            [-51, 68],
            [-37, 14],
            [-9, 34],
            [-45, 6],
            [-28, 32],
            [-74, 12],
            [-20, 19],
            [-10, 65],
            [-77, 119],
            [-67, 165],
            [3, 28],
            [-35, 39],
            [-61, 99],
            [-11, 97],
            [-43, 65],
            [18, 98],
            [-3, 102],
            [-26, 91],
            [32, 111],
            [9, 108],
            [10, 108],
            [-15, 159],
            [-25, 101],
            [-23, 55],
            [10, 23],
            [115, -40],
            [42, -112],
            [20, 32],
            [-13, 97],
            [-27, 97],
        ],
        [
            [2148, 13370],
            [-79, -46],
            [-41, 31],
            [-12, 56],
            [72, 42],
            [43, 18],
            [52, -8],
            [34, -37],
            [-69, -56],
        ],
        [
            [1148, 13701],
            [-49, -18],
            [-52, 22],
            [-49, 32],
            [79, 20],
            [63, -11],
            [8, -45],
        ],
        [
            [658, 14160],
            [49, -22],
            [50, 12],
            [64, -31],
            [79, -16],
            [-6, -13],
            [-61, -25],
            [-60, 26],
            [-31, 21],
            [-70, -7],
            [-19, 11],
            [5, 44],
        ],
        [
            [3937, 13095],
            [0, 0],
            [-44, 45],
            [-70, 38],
            [-23, 103],
            [-102, 96],
            [-43, 112],
            [-77, 8],
            [-126, 3],
            [-93, 34],
            [-165, 123],
            [-76, 22],
            [-139, 43],
            [-111, -10],
            [-156, 54],
            [-95, 51],
            [-88, -26],
            [16, -82],
            [-44, -8],
            [-92, -24],
            [-70, -40],
            [-88, -25],
            [-11, 69],
            [35, 117],
            [85, 36],
            [-22, 30],
            [-101, -66],
            [-55, -79],
            [-114, -84],
            [58, -58],
            [-75, -85],
            [-86, -50],
            [-79, -36],
            [-20, -53],
            [-124, -61],
            [-26, -55],
            [-93, -51],
            [-54, 9],
            [-75, -33],
            [-80, -40],
            [-67, -40],
            [-136, -34],
            [-13, 20],
            [87, 55],
            [78, 37],
            [85, 65],
            [99, 13],
            [39, 49],
            [110, 71],
            [18, 24],
            [59, 41],
            [14, 90],
            [40, 70],
            [-92, -36],
            [-25, 21],
            [-43, -43],
            [-52, 60],
            [-22, -43],
            [-30, 60],
            [-79, -48],
            [-49, 0],
            [-7, 71],
            [15, 43],
            [-52, 42],
            [-103, -22],
            [-67, 55],
            [-55, 29],
            [0, 67],
            [-61, 51],
            [30, 68],
            [65, 66],
            [29, 61],
            [64, 8],
            [55, -18],
            [64, 57],
            [58, -10],
            [60, 36],
            [-15, 54],
            [-44, 22],
            [59, 46],
            [-49, -2],
            [-85, -26],
            [-24, -26],
            [-63, 26],
            [-112, -13],
            [-117, 29],
            [-33, 47],
            [-101, 69],
            [112, 50],
            [178, 58],
            [65, 0],
            [-11, -60],
            [168, 5],
            [-64, 74],
            [-98, 45],
            [-57, 59],
            [-76, 51],
            [-110, 37],
            [45, 62],
            [141, 4],
            [101, 54],
            [18, 58],
            [82, 56],
            [77, 14],
            [151, 52],
            [73, -8],
            [123, 64],
            [120, -25],
            [58, -54],
            [35, 23],
            [135, -7],
            [-5, -27],
            [122, -20],
            [81, 12],
            [168, -38],
            [153, -11],
            [61, -16],
            [106, 20],
            [121, -36],
            [86, -16],
        ],
        [
            [8648, 7992],
            [-2, -28],
            [-46, -14],
            [25, -53],
            [0, -62],
            [-36, -69],
            [31, -94],
            [34, 7],
            [18, 86],
            [-25, 42],
            [-4, 90],
            [99, 48],
            [-11, 56],
            [28, 37],
            [29, -83],
            [55, -2],
            [52, -66],
            [3, -40],
            [72, -1],
            [85, 13],
            [45, -54],
            [61, -14],
            [45, 37],
            [1, 30],
            [98, 7],
            [96, 1],
            [-68, -35],
            [27, -56],
            [64, -8],
            [60, -59],
            [13, -95],
            [41, 3],
            [32, -28],
        ],
        [
            [22925, 9152],
            [-106, -102],
            [-67, -112],
            [-17, -82],
            [61, -125],
            [74, -155],
            [72, -73],
            [49, -96],
            [36, -219],
            [-11, -209],
            [-66, -78],
            [-91, -76],
            [-65, -99],
            [-99, -110],
            [-29, 76],
            [22, 80],
            [-59, 67],
        ],
        [
            [27684, 4643],
            [-27, -16],
            [-26, 52],
            [3, 32],
            [50, -68],
        ],
        [
            [27625, 4824],
            [13, -95],
            [-22, 15],
            [-16, -7],
            [-11, 33],
            [-2, 91],
            [38, -37],
        ],
        [
            [18552, 8570],
            [-57, -31],
            [-16, -53],
            [-2, -41],
            [-79, -50],
            [-127, -55],
            [-71, -84],
            [-35, -6],
            [-24, 7],
            [-47, -49],
            [-50, -23],
            [-67, -6],
            [-20, -7],
            [-18, -31],
            [-21, -9],
            [-12, -30],
            [-39, 2],
            [-26, -16],
            [-55, 6],
            [-21, 70],
            [3, 64],
            [-13, 35],
            [-16, 88],
            [-23, 49],
            [16, 6],
            [-8, 54],
            [10, 23],
            [-4, 51],
        ],
        [
            [16668, 3976],
            [32, -2],
            [39, -20],
            [27, 14],
            [42, -11],
        ],
        [
            [16938, 3424],
            [-20, -86],
            [-9, -99],
            [-21, -53],
            [-54, -60],
            [-15, -17],
            [-34, -61],
            [-22, -61],
            [-45, -85],
            [-90, -122],
            [-57, -71],
            [-60, -54],
            [-83, -46],
            [-40, -6],
            [-11, -33],
            [-48, 17],
            [-39, -22],
            [-87, 23],
            [-48, -15],
            [-33, 6],
            [-82, -47],
            [-68, -18],
            [-49, -45],
            [-36, -3],
            [-34, 42],
            [-27, 2],
            [-34, 53],
            [-4, -16],
            [-10, 32],
            [0, 69],
            [-26, 80],
            [26, 21],
            [-2, 92],
            [-52, 111],
            [-40, 100],
            [-1, 0],
            [-57, 154],
        ],
        [
            [16735, 4756],
            [-60, -16],
            [-46, -47],
            [-9, -41],
            [-29, -10],
            [-69, -97],
            [-44, -77],
            [-27, -3],
            [-26, 14],
            [-89, 13],
        ],
        [
            [21714, 8124],
            [-1, 48],
            [8, 28],
            [10, 2],
            [-1, -58],
            [-6, -7],
            [4, -1],
            [-2, -7],
            [-2, 7],
            [-10, -12],
        ],
        [
            [21704, 8103],
            [-4, 29],
            [5, 2],
            [-1, -31],
        ],
        [
            [21707, 8054],
            [-4, 10],
            [4, 52],
            [14, 8],
            [5, -48],
            [-8, -20],
            [-11, -2],
        ],
        [
            [21708, 8039],
            [-1, 11],
            [13, -4],
            [-11, -19],
            [2, -18],
            [-7, -54],
            [-14, 45],
            [7, 7],
            [3, 34],
            [8, -2],
        ],
        [
            [21734, 8025],
            [-3, 5],
            [3, 9],
            [0, -14],
        ],
        [
            [21693, 7939],
            [2, 15],
            [7, -13],
            [-9, -2],
        ],
        [
            [21702, 7927],
            [2, 11],
            [1, -1],
            [-3, -10],
        ],
        [
            [21731, 8003],
            [-8, 12],
            [7, 21],
            [1, -33],
        ],
        [
            [21689, 7841],
            [-11, 6],
            [-1, 24],
            [11, 17],
            [8, -22],
            [-7, -25],
        ],
        [
            [21710, 7676],
            [-4, 10],
            [6, 6],
            [-2, -16],
        ],
        [
            [21777, 7594],
            [1, 15],
            [2, -9],
            [-3, -6],
        ],
        [
            [21741, 7565],
            [-6, 6],
            [3, 3],
            [3, -9],
        ],
        [
            [21772, 7534],
            [-6, 9],
            [2, 17],
            [4, -26],
        ],
        [
            [21763, 7528],
            [-12, 11],
            [7, 8],
            [5, -19],
        ],
        [
            [21779, 7457],
            [-2, 15],
            [10, -2],
            [-8, -13],
        ],
        [
            [21794, 7396],
            [-14, 31],
            [13, 27],
            [12, -29],
            [-11, -29],
        ],
        [
            [21371, 9398],
            [28, -89],
            [12, -98],
            [-11, -43],
            [-54, 2],
            [-98, -25],
            [4, -89],
            [-42, -70],
            [-115, -80],
            [-89, -140],
            [-60, -75],
            [-79, -77],
            [0, -55],
            [-40, -29],
            [-72, -42],
            [-37, -7],
            [-24, -90],
            [17, -154],
            [4, -99],
            [-34, -113],
            [0, -201],
            [-41, -6],
            [-36, -90],
            [24, -39],
            [-73, -34],
            [-26, -81],
            [-32, -34],
            [-76, 111],
            [-37, 166],
            [-30, 120],
            [-28, 56],
            [-42, 114],
            [-20, 148],
            [-14, 74],
            [-72, 163],
            [-33, 230],
            [-24, 152],
            [0, 143],
            [-15, 111],
            [-116, -71],
            [-56, 15],
            [-104, 143],
            [38, 43],
            [-23, 47],
            [-94, 101],
            [0, 0],
        ],
    ],
    transform: {
        scale: [0.012565006457017207, 0.008431639622184548],
        translate: [-180, -55.61183],
    },
    objects: {
        countries: {
            type: 'GeometryCollection',
            geometries: [
                {
                    arcs: [[0, 1, 2, 3, 4, 5, 6]],
                    type: 'Polygon',
                    properties: { name: 'Afghanistan', country: 'AF' },
                },
                {
                    arcs: [[[7, 8, 9, 10]], [[11, 12, 13]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Angola', country: 'AO' },
                },
                {
                    arcs: [[14, 15, 16, 17, 18]],
                    type: 'Polygon',
                    properties: { name: 'Albania', country: 'AL' },
                },
                {
                    arcs: [[19, 20, 21, 22, 23]],
                    type: 'Polygon',
                    properties: { name: 'United Arab Emirates', country: 'AE' },
                },
                {
                    arcs: [[[24, 25]], [[26, 27, 28, 29, 30, 31]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Argentina', country: 'AR' },
                },
                {
                    arcs: [[32, 33, 34, 35, 36]],
                    type: 'Polygon',
                    properties: { name: 'Armenia', country: 'AM' },
                },
                {
                    arcs: [[37]],
                    type: 'Polygon',
                    properties: { name: 'French Southern and Antarctic Lands', country: 'TF' },
                },
                {
                    arcs: [[[38]], [[39]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Australia', country: 'AU' },
                },
                {
                    arcs: [[40, 41, 42, 43, 44, 45, 46]],
                    type: 'Polygon',
                    properties: { name: 'Austria', country: 'AT' },
                },
                {
                    arcs: [[[-36, 47]], [[-34, 48, 49, 50, 51]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Azerbaijan', country: 'AZ' },
                },
                {
                    arcs: [[52, 53, 54]],
                    type: 'Polygon',
                    properties: { name: 'Burundi', country: 'BI' },
                },
                {
                    arcs: [[55, 56, 57, 58, 59, 60]],
                    type: 'Polygon',
                    properties: { name: 'Belgium', country: 'BE' },
                },
                {
                    arcs: [[61, 62, 63, 64, 65]],
                    type: 'Polygon',
                    properties: { name: 'Benin', country: 'BJ' },
                },
                {
                    arcs: [[-64, 66, 67, 68, 69, 70]],
                    type: 'Polygon',
                    properties: { name: 'Burkina Faso', country: 'BF' },
                },
                {
                    arcs: [[71, 72, 73]],
                    type: 'Polygon',
                    properties: { name: 'Bangladesh', country: 'BD' },
                },
                {
                    arcs: [[74, 75, 76, 77, 78, 79]],
                    type: 'Polygon',
                    properties: { name: 'Bulgaria', country: 'BG' },
                },
                {
                    arcs: [[[80]], [[81]], [[82]]],
                    type: 'MultiPolygon',
                    properties: { name: 'The Bahamas', country: 'BS' },
                },
                {
                    arcs: [[83, 84, 85, 86]],
                    type: 'Polygon',
                    properties: { name: 'Bosnia and Herzegovina', country: 'BA' },
                },
                {
                    arcs: [[87, 88, 89, 90, 91]],
                    type: 'Polygon',
                    properties: { name: 'Belarus', country: 'BY' },
                },
                {
                    arcs: [[92, 93, 94]],
                    type: 'Polygon',
                    properties: { name: 'Belize', country: 'BZ' },
                },
                {
                    arcs: [[-32, 95, 96, 97, 98]],
                    type: 'Polygon',
                    properties: { name: 'Bolivia', country: 'BO' },
                },
                {
                    arcs: [[-28, 99, -98, 100, 101, 102, 103, 104, 105, 106, 107]],
                    type: 'Polygon',
                    properties: { name: 'Brazil', country: 'BR' },
                },
                {
                    arcs: [[108, 109]],
                    type: 'Polygon',
                    properties: { name: 'Brunei', country: 'BN' },
                },
                {
                    arcs: [[110, 111, 112]],
                    type: 'Polygon',
                    properties: { name: 'Bhutan', country: 'BT' },
                },
                {
                    arcs: [[113, 114, 115, 116]],
                    type: 'Polygon',
                    properties: { name: 'Botswana', country: 'BW' },
                },
                {
                    arcs: [[117, 118, 119, 120, 121, 122]],
                    type: 'Polygon',
                    properties: { name: 'Central African Republic', country: 'CF' },
                },
                {
                    arcs: [
                        [[123]],
                        [[124]],
                        [[125]],
                        [[126]],
                        [[127]],
                        [[128]],
                        [[129]],
                        [[130]],
                        [[131]],
                        [[132]],
                        [[133, 134, 135, 136]],
                        [[137]],
                        [[138]],
                        [[139]],
                        [[140]],
                        [[141]],
                        [[142]],
                        [[143]],
                        [[144]],
                        [[145]],
                        [[146]],
                        [[147]],
                        [[148]],
                        [[149]],
                        [[150]],
                        [[151]],
                        [[152]],
                        [[153]],
                        [[154]],
                        [[155]],
                    ],
                    type: 'MultiPolygon',
                    properties: { name: 'Canada', country: 'CA' },
                },
                {
                    arcs: [[-44, 156, 157, 158]],
                    type: 'Polygon',
                    properties: { name: 'Switzerland', country: 'CH' },
                },
                {
                    arcs: [[[-25, 159]], [[-31, 160, 161, -96]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Chile', country: 'CL' },
                },
                {
                    arcs: [
                        [[162]],
                        [
                            [
                                -4,
                                163,
                                164,
                                165,
                                166,
                                167,
                                168,
                                169,
                                170,
                                171,
                                172,
                                173,
                                174,
                                -112,
                                175,
                                176,
                                177,
                                178,
                            ],
                        ],
                    ],
                    type: 'MultiPolygon',
                    properties: { name: 'China', country: 'CN' },
                },
                {
                    arcs: [[-69, 179, 180, 181, 182, 183]],
                    type: 'Polygon',
                    properties: { name: 'Ivory Coast', country: 'CI' },
                },
                {
                    arcs: [[-123, 184, 185, 186, 187, 188, 189, 190]],
                    type: 'Polygon',
                    properties: { name: 'Cameroon', country: 'CM' },
                },
                {
                    arcs: [[-11, 191, -14, 192, -121, 193, 194, 195, -53, 196, 197]],
                    type: 'Polygon',
                    properties: { name: 'Democratic Republic of the Congo', country: 'CD' },
                },
                {
                    arcs: [[-13, 198, 199, -185, -122, -193]],
                    type: 'Polygon',
                    properties: { name: 'Republic of the Congo', country: 'CG' },
                },
                {
                    arcs: [[-102, 200, 201, 202, 203, 204, 205]],
                    type: 'Polygon',
                    properties: { name: 'Colombia', country: 'CO' },
                },
                {
                    arcs: [[206, 207, 208, 209]],
                    type: 'Polygon',
                    properties: { name: 'Costa Rica', country: 'CR' },
                },
                { arcs: [[210]], type: 'Polygon', properties: { name: 'Cuba', country: 'CU' } },
                {
                    arcs: [[211, 212]],
                    type: 'Polygon',
                    properties: { name: 'Northern Cyprus', country: '-99' },
                },
                {
                    arcs: [[-213, 213]],
                    type: 'Polygon',
                    properties: { name: 'Cyprus', country: 'CY' },
                },
                {
                    arcs: [[-46, 214, 215, 216]],
                    type: 'Polygon',
                    properties: { name: 'Czech Republic', country: 'CZ' },
                },
                {
                    arcs: [[-45, -159, 217, 218, -57, 219, 220, 221, 222, 223, -215]],
                    type: 'Polygon',
                    properties: { name: 'Germany', country: 'DE' },
                },
                {
                    arcs: [[224, 225, 226, 227]],
                    type: 'Polygon',
                    properties: { name: 'Djibouti', country: 'DJ' },
                },
                {
                    arcs: [[[228]], [[-222, 229]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Denmark', country: 'DK' },
                },
                {
                    arcs: [[230, 231]],
                    type: 'Polygon',
                    properties: { name: 'Dominican Republic', country: 'DO' },
                },
                {
                    arcs: [[232, 233, 234, 235, 236, 237, 238, 239]],
                    type: 'Polygon',
                    properties: { name: 'Algeria', country: 'DZ' },
                },
                {
                    arcs: [[-202, 240, 241]],
                    type: 'Polygon',
                    properties: { name: 'Ecuador', country: 'EC' },
                },
                {
                    arcs: [[242, 243, 244, 245, 246]],
                    type: 'Polygon',
                    properties: { name: 'Egypt', country: 'EG' },
                },
                {
                    arcs: [[-228, 247, 248, 249]],
                    type: 'Polygon',
                    properties: { name: 'Eritrea', country: 'ER' },
                },
                {
                    arcs: [[250, 251, 252, 253]],
                    type: 'Polygon',
                    properties: { name: 'Spain', country: 'ES' },
                },
                {
                    arcs: [[254, 255, 256]],
                    type: 'Polygon',
                    properties: { name: 'Estonia', country: 'EE' },
                },
                {
                    arcs: [[-248, -227, 257, 258, 259, 260, 261]],
                    type: 'Polygon',
                    properties: { name: 'Ethiopia', country: 'ET' },
                },
                {
                    arcs: [[262, 263, 264, 265]],
                    type: 'Polygon',
                    properties: { name: 'Finland', country: 'FI' },
                },
                {
                    arcs: [[[266]], [[267]], [[268]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Fiji', country: 'FJ' },
                },
                {
                    arcs: [[269]],
                    type: 'Polygon',
                    properties: { name: 'Falkland Islands', country: 'FK' },
                },
                {
                    arcs: [
                        [[270, 271, -106]],
                        [[272]],
                        [[-59, 273, -218, -158, 274, 275, -252, 276]],
                    ],
                    type: 'MultiPolygon',
                    properties: { name: 'France', country: 'FR' },
                },
                {
                    arcs: [[-186, -200, 277, 278]],
                    type: 'Polygon',
                    properties: { name: 'Gabon', country: 'GA' },
                },
                {
                    arcs: [[[279, 280]], [[281]]],
                    type: 'MultiPolygon',
                    properties: { name: 'United Kingdom', country: 'GB' },
                },
                {
                    arcs: [[-33, 282, 283, 284, -49]],
                    type: 'Polygon',
                    properties: { name: 'Georgia', country: 'GE' },
                },
                {
                    arcs: [[-68, 285, 286, -180]],
                    type: 'Polygon',
                    properties: { name: 'Ghana', country: 'GH' },
                },
                {
                    arcs: [[-183, 287, 288, 289, 290, 291, 292]],
                    type: 'Polygon',
                    properties: { name: 'Guinea', country: 'GN' },
                },
                {
                    arcs: [[293, 294]],
                    type: 'Polygon',
                    properties: { name: 'Gambia', country: 'GM' },
                },
                {
                    arcs: [[-291, 295, 296]],
                    type: 'Polygon',
                    properties: { name: 'Guinea Bissau', country: 'GW' },
                },
                {
                    arcs: [[-187, -279, 297]],
                    type: 'Polygon',
                    properties: { name: 'Equatorial Guinea', country: 'GQ' },
                },
                {
                    arcs: [[[298]], [[-15, 299, -78, 300, 301]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Greece', country: 'GR' },
                },
                {
                    arcs: [[302]],
                    type: 'Polygon',
                    properties: { name: 'Greenland', country: 'GL' },
                },
                {
                    arcs: [[-95, 303, 304, 305, 306, 307]],
                    type: 'Polygon',
                    properties: { name: 'Guatemala', country: 'GT' },
                },
                {
                    arcs: [[-104, 308, 309, 310]],
                    type: 'Polygon',
                    properties: { name: 'Guyana', country: 'GY' },
                },
                {
                    arcs: [[-305, 311, 312, 313, 314]],
                    type: 'Polygon',
                    properties: { name: 'Honduras', country: 'HN' },
                },
                {
                    arcs: [[-86, 315, 316, 317, 318, 319]],
                    type: 'Polygon',
                    properties: { name: 'Croatia', country: 'HR' },
                },
                {
                    arcs: [[-232, 320]],
                    type: 'Polygon',
                    properties: { name: 'Haiti', country: 'HT' },
                },
                {
                    arcs: [[-41, 321, 322, 323, 324, -319, 325]],
                    type: 'Polygon',
                    properties: { name: 'Hungary', country: 'HU' },
                },
                {
                    arcs: [
                        [[326]],
                        [[327, 328]],
                        [[329]],
                        [[330]],
                        [[331]],
                        [[332]],
                        [[333]],
                        [[334]],
                        [[335, 336]],
                        [[337]],
                        [[338]],
                        [[339, 340]],
                        [[341]],
                    ],
                    type: 'MultiPolygon',
                    properties: { name: 'Indonesia', country: 'ID' },
                },
                {
                    arcs: [[-280, 342]],
                    type: 'Polygon',
                    properties: { name: 'Ireland', country: 'IE' },
                },
                {
                    arcs: [[-7, 343, 344, 345, 346, -48, -35, -52, 347, 348]],
                    type: 'Polygon',
                    properties: { name: 'Iran', country: 'IR' },
                },
                {
                    arcs: [[-346, 349, 350, 351, 352, 353, 354]],
                    type: 'Polygon',
                    properties: { name: 'Iraq', country: 'IQ' },
                },
                { arcs: [[355]], type: 'Polygon', properties: { name: 'Iceland', country: 'IS' } },
                {
                    arcs: [[-246, 356, 357, 358, 359, 360, 361, 362]],
                    type: 'Polygon',
                    properties: { name: 'Israel', country: 'IL' },
                },
                {
                    arcs: [[[363]], [[364]], [[-43, 365, 366, -275, -157]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Italy', country: 'IT' },
                },
                { arcs: [[367]], type: 'Polygon', properties: { name: 'Jamaica', country: 'JM' } },
                {
                    arcs: [[-353, 368, 369, -362, 370, -360, 371]],
                    type: 'Polygon',
                    properties: { name: 'Jordan', country: 'JO' },
                },
                {
                    arcs: [[[372]], [[373]], [[374]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Japan', country: 'JP' },
                },
                {
                    arcs: [[-166, 375, 376, 377, 378, 379]],
                    type: 'Polygon',
                    properties: { name: 'Kazakhstan', country: 'KZ' },
                },
                {
                    arcs: [[-260, 380, 381, 382, 383, 384]],
                    type: 'Polygon',
                    properties: { name: 'Kenya', country: 'KE' },
                },
                {
                    arcs: [[-165, 385, 386, -376]],
                    type: 'Polygon',
                    properties: { name: 'Kyrgyzstan', country: 'KG' },
                },
                {
                    arcs: [[387, 388, 389, 390]],
                    type: 'Polygon',
                    properties: { name: 'Cambodia', country: 'KH' },
                },
                {
                    arcs: [[391, 392]],
                    type: 'Polygon',
                    properties: { name: 'South Korea', country: 'KR' },
                },
                {
                    arcs: [[-18, 393, 394, 395]],
                    type: 'Polygon',
                    properties: { name: 'Kosovo', country: '-99' },
                },
                {
                    arcs: [[-351, 396, 397]],
                    type: 'Polygon',
                    properties: { name: 'Kuwait', country: 'KW' },
                },
                {
                    arcs: [[-173, 398, -389, 399, 400]],
                    type: 'Polygon',
                    properties: { name: 'Laos', country: 'LA' },
                },
                {
                    arcs: [[-358, 401, 402]],
                    type: 'Polygon',
                    properties: { name: 'Lebanon', country: 'LB' },
                },
                {
                    arcs: [[-182, 403, 404, -288]],
                    type: 'Polygon',
                    properties: { name: 'Liberia', country: 'LR' },
                },
                {
                    arcs: [[-240, 405, 406, -244, 407, 408, 409]],
                    type: 'Polygon',
                    properties: { name: 'Libya', country: 'LY' },
                },
                {
                    arcs: [[410]],
                    type: 'Polygon',
                    properties: { name: 'Sri Lanka', country: 'LK' },
                },
                { arcs: [[411]], type: 'Polygon', properties: { name: 'Lesotho', country: 'LS' } },
                {
                    arcs: [[-88, 412, 413, 414, 415]],
                    type: 'Polygon',
                    properties: { name: 'Lithuania', country: 'LT' },
                },
                {
                    arcs: [[-58, -219, -274]],
                    type: 'Polygon',
                    properties: { name: 'Luxembourg', country: 'LU' },
                },
                {
                    arcs: [[-89, -416, 416, -257, 417]],
                    type: 'Polygon',
                    properties: { name: 'Latvia', country: 'LV' },
                },
                {
                    arcs: [[-237, 418, 419]],
                    type: 'Polygon',
                    properties: { name: 'Morocco', country: 'MA' },
                },
                {
                    arcs: [[420, 421]],
                    type: 'Polygon',
                    properties: { name: 'Moldova', country: 'MD' },
                },
                {
                    arcs: [[422]],
                    type: 'Polygon',
                    properties: { name: 'Madagascar', country: 'MG' },
                },
                {
                    arcs: [[-93, -308, 423, 424, 425]],
                    type: 'Polygon',
                    properties: { name: 'Mexico', country: 'MX' },
                },
                {
                    arcs: [[-19, -396, 426, -79, -300]],
                    type: 'Polygon',
                    properties: { name: 'Macedonia', country: 'MK' },
                },
                {
                    arcs: [[-70, -184, -293, 427, 428, -234, 429]],
                    type: 'Polygon',
                    properties: { name: 'Mali', country: 'ML' },
                },
                {
                    arcs: [[-72, 430, -174, -401, 431, 432]],
                    type: 'Polygon',
                    properties: { name: 'Myanmar', country: 'MM' },
                },
                {
                    arcs: [[-17, 433, -316, -85, 434, -394]],
                    type: 'Polygon',
                    properties: { name: 'Montenegro', country: 'ME' },
                },
                {
                    arcs: [[-168, 435]],
                    type: 'Polygon',
                    properties: { name: 'Mongolia', country: 'MN' },
                },
                {
                    arcs: [[436, 437, 438, 439, 440, 441, 442, 443]],
                    type: 'Polygon',
                    properties: { name: 'Mozambique', country: 'MZ' },
                },
                {
                    arcs: [[-235, -429, 444, 445, 446]],
                    type: 'Polygon',
                    properties: { name: 'Mauritania', country: 'MR' },
                },
                {
                    arcs: [[-444, 447, 448]],
                    type: 'Polygon',
                    properties: { name: 'Malawi', country: 'MW' },
                },
                {
                    arcs: [[[449, 450]], [[-110, 451, -340, 452]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Malaysia', country: 'MY' },
                },
                {
                    arcs: [[-9, 453, -115, 454, 455]],
                    type: 'Polygon',
                    properties: { name: 'Namibia', country: 'NA' },
                },
                {
                    arcs: [[456]],
                    type: 'Polygon',
                    properties: { name: 'New Caledonia', country: 'NC' },
                },
                {
                    arcs: [[-65, -71, -430, -233, -410, 457, -190, 458]],
                    type: 'Polygon',
                    properties: { name: 'Niger', country: 'NE' },
                },
                {
                    arcs: [[-66, -459, -189, 459]],
                    type: 'Polygon',
                    properties: { name: 'Nigeria', country: 'NG' },
                },
                {
                    arcs: [[-208, 460, -313, 461]],
                    type: 'Polygon',
                    properties: { name: 'Nicaragua', country: 'NI' },
                },
                {
                    arcs: [[-56, -61, 462, -220]],
                    type: 'Polygon',
                    properties: { name: 'Netherlands', country: 'NL' },
                },
                {
                    arcs: [[[-266, 463, 464, 465]], [[466]], [[467]], [[468]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Norway', country: 'NO' },
                },
                {
                    arcs: [[-177, 469]],
                    type: 'Polygon',
                    properties: { name: 'Nepal', country: 'NP' },
                },
                {
                    arcs: [[[470]], [[471]]],
                    type: 'MultiPolygon',
                    properties: { name: 'New Zealand', country: 'NZ' },
                },
                {
                    arcs: [[[-23, 472, 473, 474]], [[-21, 475]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Oman', country: 'OM' },
                },
                {
                    arcs: [[-6, 476, 477, -344]],
                    type: 'Polygon',
                    properties: { name: 'Pakistan', country: 'PK' },
                },
                {
                    arcs: [[-204, 478, -210, 479]],
                    type: 'Polygon',
                    properties: { name: 'Panama', country: 'PA' },
                },
                {
                    arcs: [[-97, -162, 480, -241, -201, -101]],
                    type: 'Polygon',
                    properties: { name: 'Peru', country: 'PE' },
                },
                {
                    arcs: [[[481]], [[482]], [[483]], [[484]], [[485]], [[486]], [[487]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Philippines', country: 'PH' },
                },
                {
                    arcs: [[[488]], [[489]], [[-336, 490]], [[491]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Papua New Guinea', country: 'PG' },
                },
                {
                    arcs: [[-92, 492, 493, -216, -224, 494, 495, -413]],
                    type: 'Polygon',
                    properties: { name: 'Poland', country: 'PL' },
                },
                {
                    arcs: [[496]],
                    type: 'Polygon',
                    properties: { name: 'Puerto Rico', country: 'PR' },
                },
                {
                    arcs: [[-170, 497, 498, -393, 499]],
                    type: 'Polygon',
                    properties: { name: 'North Korea', country: 'KP' },
                },
                {
                    arcs: [[-254, 500]],
                    type: 'Polygon',
                    properties: { name: 'Portugal', country: 'PT' },
                },
                {
                    arcs: [[-27, -99, -100]],
                    type: 'Polygon',
                    properties: { name: 'Paraguay', country: 'PY' },
                },
                {
                    arcs: [[501, 502]],
                    type: 'Polygon',
                    properties: { name: 'Qatar', country: 'QA' },
                },
                {
                    arcs: [[-75, 503, -324, 504, -422, 505, 506]],
                    type: 'Polygon',
                    properties: { name: 'Romania', country: 'RO' },
                },
                {
                    arcs: [
                        [[507]],
                        [[-414, -496, 508]],
                        [[509]],
                        [[510]],
                        [[511]],
                        [[512]],
                        [[513]],
                        [[514]],
                        [[515]],
                        [
                            [
                                -50,
                                -285,
                                516,
                                517,
                                -90,
                                -418,
                                -256,
                                518,
                                -263,
                                -466,
                                519,
                                -498,
                                -169,
                                -436,
                                -167,
                                -380,
                                520,
                            ],
                        ],
                        [[521]],
                        [[522]],
                        [[523]],
                    ],
                    type: 'MultiPolygon',
                    properties: { name: 'Russia', country: 'RU' },
                },
                {
                    arcs: [[-54, -196, 524, 525]],
                    type: 'Polygon',
                    properties: { name: 'Rwanda', country: 'RW' },
                },
                {
                    arcs: [[-236, -447, 526, -419]],
                    type: 'Polygon',
                    properties: { name: 'Western Sahara', country: '-99' },
                },
                {
                    arcs: [[-24, -475, 527, 528, -369, -352, -398, 529, -503, 530]],
                    type: 'Polygon',
                    properties: { name: 'Saudi Arabia', country: 'SA' },
                },
                {
                    arcs: [[-262, 531, -119, 532, -408, -243, 533, -249]],
                    type: 'Polygon',
                    properties: { name: 'Sudan', country: 'SD' },
                },
                {
                    arcs: [[-120, -532, -261, -385, 534, -194]],
                    type: 'Polygon',
                    properties: { name: 'South Sudan', country: 'SDS' },
                },
                {
                    arcs: [[-292, -297, 535, -295, 536, -445, -428]],
                    type: 'Polygon',
                    properties: { name: 'Senegal', country: 'SN' },
                },
                {
                    arcs: [[[537]], [[538]], [[539]], [[540]], [[541]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Solomon Islands', country: 'SB' },
                },
                {
                    arcs: [[-289, -405, 542]],
                    type: 'Polygon',
                    properties: { name: 'Sierra Leone', country: 'SL' },
                },
                {
                    arcs: [[-306, -315, 543]],
                    type: 'Polygon',
                    properties: { name: 'El Salvador', country: 'SV' },
                },
                {
                    arcs: [[-226, 544, 545, -258]],
                    type: 'Polygon',
                    properties: { name: 'Somaliland', country: '-99' },
                },
                {
                    arcs: [[-259, -546, 546, -381]],
                    type: 'Polygon',
                    properties: { name: 'Somalia', country: 'SO' },
                },
                {
                    arcs: [[-80, -427, -395, -435, -84, -87, -320, -325, -504]],
                    type: 'Polygon',
                    properties: { name: 'Republic of Serbia', country: 'RS' },
                },
                {
                    arcs: [[-105, -311, 547, -271]],
                    type: 'Polygon',
                    properties: { name: 'Suriname', country: 'SR' },
                },
                {
                    arcs: [[-47, -217, -494, 548, -322]],
                    type: 'Polygon',
                    properties: { name: 'Slovakia', country: 'SK' },
                },
                {
                    arcs: [[-42, -326, -318, 549, -366]],
                    type: 'Polygon',
                    properties: { name: 'Slovenia', country: 'SI' },
                },
                {
                    arcs: [[-265, 550, -464]],
                    type: 'Polygon',
                    properties: { name: 'Sweden', country: 'SE' },
                },
                {
                    arcs: [[-440, 551]],
                    type: 'Polygon',
                    properties: { name: 'Swaziland', country: 'SZ' },
                },
                {
                    arcs: [[-354, -372, -359, -403, 552, 553]],
                    type: 'Polygon',
                    properties: { name: 'Syria', country: 'SY' },
                },
                {
                    arcs: [[-118, -191, -458, -409, -533]],
                    type: 'Polygon',
                    properties: { name: 'Chad', country: 'TD' },
                },
                {
                    arcs: [[-63, 554, -286, -67]],
                    type: 'Polygon',
                    properties: { name: 'Togo', country: 'TG' },
                },
                {
                    arcs: [[-388, 555, -451, 556, -432, -400]],
                    type: 'Polygon',
                    properties: { name: 'Thailand', country: 'TH' },
                },
                {
                    arcs: [[-3, 557, -386, -164]],
                    type: 'Polygon',
                    properties: { name: 'Tajikistan', country: 'TJ' },
                },
                {
                    arcs: [[-1, -349, 558, -378, 559]],
                    type: 'Polygon',
                    properties: { name: 'Turkmenistan', country: 'TM' },
                },
                {
                    arcs: [[-328, 560]],
                    type: 'Polygon',
                    properties: { name: 'East Timor', country: 'TL' },
                },
                {
                    arcs: [[561]],
                    type: 'Polygon',
                    properties: { name: 'Trinidad and Tobago', country: 'TT' },
                },
                {
                    arcs: [[-239, 562, -406]],
                    type: 'Polygon',
                    properties: { name: 'Tunisia', country: 'TN' },
                },
                {
                    arcs: [[[-37, -347, -355, -554, 563, -283]], [[-77, 564, -301]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Turkey', country: 'TR' },
                },
                { arcs: [[565]], type: 'Polygon', properties: { name: 'Taiwan', country: 'TW' } },
                {
                    arcs: [[-526, 566, -383, 567, -437, -449, 568, -197, -55]],
                    type: 'Polygon',
                    properties: { name: 'United Republic of Tanzania', country: 'TZ' },
                },
                {
                    arcs: [[-195, -535, -384, -567, -525]],
                    type: 'Polygon',
                    properties: { name: 'Uganda', country: 'UG' },
                },
                {
                    arcs: [[-91, -518, 569, -506, -421, -505, -323, -549, -493]],
                    type: 'Polygon',
                    properties: { name: 'Ukraine', country: 'UA' },
                },
                {
                    arcs: [[-29, -108, 570]],
                    type: 'Polygon',
                    properties: { name: 'Uruguay', country: 'UY' },
                },
                {
                    arcs: [
                        [[571]],
                        [[572]],
                        [[573]],
                        [[574]],
                        [[575]],
                        [[-134, 576, -425, 577]],
                        [[578]],
                        [[579]],
                        [[580]],
                        [[-136, 581]],
                    ],
                    type: 'MultiPolygon',
                    properties: { name: 'United States of America', country: 'US' },
                },
                {
                    arcs: [[-2, -560, -377, -387, -558]],
                    type: 'Polygon',
                    properties: { name: 'Uzbekistan', country: 'UZ' },
                },
                {
                    arcs: [[-103, -206, 582, -309]],
                    type: 'Polygon',
                    properties: { name: 'Venezuela', country: 'VE' },
                },
                {
                    arcs: [[-172, 583, -390, -399]],
                    type: 'Polygon',
                    properties: { name: 'Vietnam', country: 'VN' },
                },
                {
                    arcs: [[[584]], [[585]]],
                    type: 'MultiPolygon',
                    properties: { name: 'Vanuatu', country: 'VU' },
                },
                {
                    arcs: [[-361, -371]],
                    type: 'Polygon',
                    properties: { name: 'West Bank', country: 'PS' },
                },
                {
                    arcs: [[-474, 586, -528]],
                    type: 'Polygon',
                    properties: { name: 'Yemen', country: 'YE' },
                },
                {
                    arcs: [[-114, 587, -441, -552, -439, 588, -455], [-412]],
                    type: 'Polygon',
                    properties: { name: 'South Africa', country: 'ZA' },
                },
                {
                    arcs: [[-8, -198, -569, -448, -443, 589, -116, -454]],
                    type: 'Polygon',
                    properties: { name: 'Zambia', country: 'ZM' },
                },
                {
                    arcs: [[-117, -590, -442, -588]],
                    type: 'Polygon',
                    properties: { name: 'Zimbabwe', country: 'ZW' },
                },
                {
                    arcs: [
                        [[590]],
                        [[591]],
                        [[592]],
                        [[593]],
                        [[594]],
                        [[595]],
                        [[596]],
                        [[597]],
                        [[598]],
                        [[599]],
                        [[600]],
                        [[601]],
                        [[602]],
                        [[603]],
                        [[604]],
                        [[605]],
                        [[-470, -176, -111, -113, -175, -431, -74, 606, -477, -5, -179, -178]],
                    ],
                    type: 'MultiPolygon',
                    properties: { name: 'India', country: 'IN' },
                },
            ],
        },
    },
};

export default data;
